// CAMPANHA DE FLY POR ETIQUETA (RDS chamados 1.30 / DA-713, ajustes na DA-714) — a tela.
//
// Duas vistas: montar uma campanha nova, e acompanhar as que estao correndo.
//
// ⛔ A PREVIA NAO E' ENFEITE — e' o motivo de a tela existir. Disparar oferta pra centenas de
// numeros nao volta atras, e a conta ja foi restringida por *"spam, mensagens automaticas ou em
// massa"* sem ter feito nada disso ([DA-509]). Ele ve A ARTE, O TEXTO, QUEM RECEBE e QUEM FICA
// DE FORA antes de confirmar — e o botao so' acende depois que a previa chegou.
//
// 🔑 O que a [DA-714] mudou, e por que: ate ela a tela dava um NUMERO ("53 contatos"), e aprovar
// uma contagem minha nao e' conferir nada. Agora as duas listas vem nomeadas e com caixa —
// desmarcar tira quem ele nao quer, marcar resgata quem o julgamento deixou de fora. E a arte
// aparece: disparar pra 53 pessoas era o unico caminho da casa em que ninguem via o fly antes.
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
  Loader2, Megaphone, Pause, Play, X, AlertTriangle, Image as ImageIcon, Search, MessageCircle,
  Check, Package, Type as TypeIcon, Plus, Minus, Instagram, Pencil, Save, Trash2, ArrowUpDown,
} from 'lucide-react';
import { ModalCarrosselInstagram } from './ModalCarrosselInstagram';
import { ModalOrdemProdutosFly } from './ModalOrdemProdutosFly';
import {
  contar, truncarParaFormatoFly, resolverNomeContato, resolverFrequencia, motivoQuantidadeFly, quantidadeFlyValida, FLY_CATALOGO_PRODUTOS, formatDataSP,
  SEM_ETIQUETA_ID, SEM_ETIQUETA_NOME,
} from '@fiodecobre/shared';
import { Avatar } from '../../components/Avatar';
import { FotoProduto } from '../../components/FotoProduto';
import { Modal } from '../../components/Modal';
import { Interruptor } from '../../components/Interruptor';
import { api } from '../../lib/api';
import { useToast } from '../../components/Toast';
import { useDialog } from '../../components/DialogProvider';
import { excluirContatoDeVez } from './excluir-contato';
import { atendimentoApi, type FlySalvo } from '../atendimento/lib/api';
import { LightboxImagem } from '../atendimento/componentes/LightboxImagem';
import { fmtEstoque } from '../atendimento/componentes/ModalEnviarMaterial';
import type { Etiqueta } from '../atendimento/lib/etiquetas-context';
import { corDoTexto, BadgeEtiqueta } from '../atendimento/componentes/BadgeEtiqueta';

interface ForaDaLista {
  /** Pra lixeira dos "numero nao entrega" (24/09/2026). */
  contato_id: number;
  nome: string | null;
  jid: string;
  chave: string;
  foto_url: string | null;
  motivo: string | null;
  texto: string | null;
  resgatavel: boolean;
  ultimo_envio: string | null;
  dias_ultimo_envio: number | null;
  etiqueta_ids?: number[];
  /** De quantos em quantos dias esta pessoa pode receber fly — a menor das etiquetas ([DA-811]). */
  frequencia_dias?: number;
}

interface QuemRecebe {
  nome: string | null;
  jid: string;
  chave: string;
  /** A pessoa (`chave_telefone_br`) — casa com o registro `fora_na_montagem` da edicao. */
  pessoa?: string;
  foto_url: string | null;
  /** `DD/MM` do ultimo fly que a loja mandou — ja formatado no banco. `null` = nunca recebeu. */
  ultimo_envio: string | null;
  dias_ultimo_envio: number | null;
  /** As etiquetas DA CAMPANHA em que esta pessoa esta. Pedido dele em 24/09/2026. */
  etiqueta_ids?: number[];
  /** De quantos em quantos dias esta pessoa pode receber fly — a menor das etiquetas ([DA-811]). */
  frequencia_dias?: number;
}

interface Previa {
  total: number;
  elegiveis: number;
  excluidos: Array<{ motivo: string; texto: string; qtd: number }>;
  frios_de_fora: number;
  teto_diario: number;
  dias_estimados: number | null;
  recebem: QuemRecebe[];
  fora: ForaDaLista[];
  /** So' na edicao: quantos desta campanha ja receberam — saem das duas listas e ficam como estao. */
  ja_na_campanha?: number;
}

/** A campanha inteira, como o `GET /api/campanhas-fly/:id` devolve pra reabrir no formulario. */
interface CampanhaParaEditar {
  id: number;
  nome: string;
  status: string;
  etiqueta_ids: number[];
  produto_ids: number[];
  fly_salvo_id: number | null;
  texto: string | null;
  incluir_frios: boolean;
  somente_texto: boolean;
  editavel: boolean;
  produtos: ProdutoEscolha[];
  /** Quem AINDA vai receber (nao saiu): a tela abre marcando exatamente estes. */
  fila: Array<{ chave: string; resgatado: boolean }>;
  /**
   * Quem ficou DE FORA na ultima montagem e por que, por pessoa (migration 0296). `null` =
   * campanha montada antes do registro existir (24/09/2026).
   */
  fora_na_montagem: Record<string, { m: string; d: string; u?: string | null }> | null;
  /** `DD/MM` da ultima montagem — quem nao esta no registro entrou na etiqueta depois. */
  fila_montada_em: string | null;
  /** `YYYY-MM-DD` — a data inicial do disparo (migration 0298). */
  inicia_em: string;
}

/** Hoje em Brasilia, `YYYY-MM-DD` — o valor que o `<input type="date">` le e escreve. */
function hojeISO(): string {
  return new Date().toLocaleDateString('en-CA', { timeZone: 'America/Sao_Paulo' });
}

interface CampanhaLinha {
  id: number;
  /** Numero de exibicao, sequencial e sem buracos (migration 0297) — o `id` tem buracos. */
  numero: number;
  nome: string;
  status: string;
  /** `YYYY-MM-DD` — antes dela o worker nao manda nada (migration 0298). */
  inicia_em: string;
  /** A data inicial ainda nao chegou — calculado no SERVIDOR, com o dia de Brasilia. */
  aguardando_inicio: boolean;
  /** Quantos sairam em cada dia (`YYYY-MM-DD`), mesma fonte do `enviados`. Nulo sem envio. */
  por_dia: Array<{ dia: string; n: number }> | null;
  etiqueta: string;
  criado_por: string | null;
  incluir_frios: boolean;
  somente_texto: boolean;
  /** Os produtos gravados — o Retomar confere a quantidade (1-3/12) antes de acender. */
  produto_ids?: number[];
  /** A arte que saiu por ULTIMO nesta campanha (a gravada no envio, nao uma previa). Nula na de
   *  texto e na de arte que ainda nao mandou nada. */
  fly_url: string | null;
  /** Estado do carrossel no Instagram (`campanha_fly_instagram`); nulo = nunca gerado. */
  instagram_status: string | null;
  total: number;
  enviados: number;
  pendentes: number;
  pulados: number;
  erros: number;
  /** [DA-821]: quantos sairam pelo complemento "Sem etiqueta" (ja contados em `enviados`). */
  complementados: number;
  ultimo_envio: string | null;
}

/** Um produto no picker AD-HOC (modo Somente Texto, e a sobra de quando ele desliga o modo). */
interface ProdutoEscolha {
  id: number;
  /** O codigo que ele usa pra falar do produto — a busca do orcamento ja o mostra assim. */
  codigo_interno: string | null;
  descricao: string;
  preco_pix: string;
  foto_url: string | null;
  /** So' importa no modo texto (decisao dele): produto sem isto nao serve pra campanha texto. */
  tem_descricao_comercial: boolean;
  /** `estoque_atual` ([DA-707]) — so' a BUSCA traz; rascunho e fly guardado vem sem. Informa, nao trava. */
  estoque?: string;
}

interface Variavel {
  chave: string;
  valor: string;
  ajuda: string;
}

/**
 * Os parametros de envio, que ele regula na aba Configuracoes (pedido dele, 21/09/2026).
 *
 * ⚠️ Os tres sao GLOBAIS, nao da campanha: o que protege o numero da loja e' o total que sai da
 * caixa, e duas campanhas ao mesmo tempo dividem a mesma cota. Foi por isso que eles sairam do
 * cabecalho da tela de criar UMA campanha — ali o teto parecia ser daquela campanha.
 */
interface ParametrosEnvio {
  teto_diario: number;
  intervalo_min: number;
  intervalo_max: number;
  janela_ativa: boolean;
  janela_inicio: string;
  janela_fim: string;
}

interface Painel {
  campanhas: CampanhaLinha[];
  teto_diario: number;
  parametros: ParametrosEnvio;
  /** Quantos minutos a loja fica aberta HOJE — o denominador da conta que a aba imprime. */
  minutos_loja_aberta_hoje: number;
  enviados_hoje: number;
  loja_aberta: boolean;
  texto_padrao: string;
  variaveis: Variavel[];
}

/**
 * A grade do intervalo descreve o motor: o worker so' manda quando acorda. Foi de 5 em 5 (escolha
 * DELE, 21/09/2026) e voltou a 1 em 07/10/2026 (*"Vamos usar entao multiplos de 1"*), com o cron
 * do `campanha-fly.scheduler` junto. Fora da grade a tela RECUSA e diz por que; nunca arredonda.
 * ⚠️ Espelho do `PASSO_INTERVALO` do `campanha-fly.regras` — o servidor e' quem tem o teste.
 */
const PASSO_INTERVALO = 1;
const INTERVALO_MINIMO = PASSO_INTERVALO;

/**
 * Quantos envios cabem numa janela de N minutos com um dado intervalo. O primeiro sai no
 * instante zero, entao e' `1 + quantos intervalos cabem`.
 *
 * ⚠️ Mesma formula do `cabemNaJanela` do servidor, de proposito — aqui ela so' desenha a previa
 * enquanto ele digita, e quem decide de verdade e' o worker. Se um dia ela decidir alguma coisa,
 * vira peca compartilhada no `shared`.
 */
function cabemNaJanela(minutosJanela: number, intervaloMinutos: number): number {
  if (minutosJanela < 0 || intervaloMinutos <= 0) return 0;
  return 1 + Math.floor(minutosJanela / intervaloMinutos);
}

function minutosEntreHoras(inicio: string, fim: string): number {
  const emMinutos = (hhmm: string) => {
    const p = hhmm.split(':');
    return Number(p[0] ?? 0) * 60 + Number(p[1] ?? 0);
  };
  return emMinutos(fim) - emMinutos(inicio);
}

interface Arte {
  imagem: string;
  legenda_produtos: string;
}

/**
 * Os produtos escolhidos pra campanha nova sobrevivem ao F5 (pedido dele, 23/09/2026). Vai junto
 * o que da' SENTIDO a lista: o modo (a mesma lista vale diferente com e sem arte) e o fly guardado
 * escolhido, que e' a outra porta da mesma escolha. `sessionStorage`, como o resto da tela: e'
 * desta aba do navegador. O produto vai INTEIRO (foto, preco) porque a tela o desenha sem nova
 * busca; o que pode ter mudado no cadastro (a Descricao Comercial) se reconfere ao restaurar —
 * e na EDICAO o produto inteiro volta do servidor (`abrirEdicao`), nao so' o selo.
 */
const CHAVE_RASCUNHO_PRODUTOS = 'campanha-fly:produtos';

interface RascunhoProdutos {
  somenteTexto: boolean;
  produtos: ProdutoEscolha[];
  flyId: number | null;
  adHocTocado: boolean;
  /** A campanha que estava em EDICAO quando o F5 veio (23/09/2026). Sem isto a recarga devolvia
   *  os produtos da edicao numa campanha NOVA, sem nome nem etiqueta — e preencher os dois ali
   *  criaria uma segunda campanha em vez de alterar a primeira. */
  editandoId: number | null;
}

function lerRascunhoProdutos(): RascunhoProdutos | null {
  try {
    const r = JSON.parse(sessionStorage.getItem(CHAVE_RASCUNHO_PRODUTOS) ?? 'null') as RascunhoProdutos | null;
    // Validado, nunca aceito como esta: formato velho ou estranho vira "sem rascunho".
    if (!r || typeof r.somenteTexto !== 'boolean' || !Array.isArray(r.produtos)
      || !r.produtos.every((p) => typeof p?.id === 'number' && typeof p?.descricao === 'string')
      || !(r.flyId === null || typeof r.flyId === 'number')) return null;
    return {
      ...r,
      adHocTocado: r.adHocTocado === true,
      editandoId: Number.isInteger(r.editandoId) && (r.editandoId as number) > 0 ? r.editandoId : null,
    };
  } catch { return null; }
}

const SEM_NOME = '(sem nome)';

/** Por que esta campanha PAUSADA nao pode retomar — `null` quando pode. Com arte, so' 1-3 ou 12. */
function motivoRetomar(c: CampanhaLinha): string | null {
  return c.somente_texto ? null : motivoQuantidadeFly(c.produto_ids?.length ?? 0);
}

/**
 * O motivo da quantidade em DUAS PALAVRAS, pro selo colado nos produtos (pedido dele, 10/10/2026,
 * com print: *"Faltam x produtos — fica mais intuitivo"*). De 4 a 11 conta o que falta pro
 * catalogo; acima de 12, o que sobra. `null` quando ja vira fly, ou com zero produto (ai a frase
 * longa ja pede o primeiro). ⚠️ A REGRA segue sendo a do `shared` (`quantidadeFlyValida`); aqui
 * mora so' o texto, pra o deploy nao reiniciar o servidor.
 */
function rotuloFaltaFly(qtd: number): string | null {
  if (qtd <= 0 || quantidadeFlyValida(qtd)) return null;
  if (qtd < FLY_CATALOGO_PRODUTOS) {
    const faltam = FLY_CATALOGO_PRODUTOS - qtd;
    return faltam === 1 ? 'Falta 1 produto' : 'Faltam ' + faltam + ' produtos';
  }
  const sobram = qtd - FLY_CATALOGO_PRODUTOS;
  return sobram === 1 ? 'Sobra 1 produto' : 'Sobram ' + sobram + ' produtos';
}

/** Os 10 digitos finais viram algo legivel: quem confere a lista le numero, nao jid. */
function telefoneLegivel(chave: string): string {
  if (chave.length !== 10) return chave;
  return '(' + chave.slice(0, 2) + ') ' + chave.slice(2, 6) + '-' + chave.slice(6);
}

/**
 * O ultimo fly que a loja mandou pra aquela pessoa, em palavras — pedido dele em 21/09/2026.
 *
 * ⚠️ A data vem PRONTA do banco (`DD/MM`, coluna `date`, sem fuso) e os dias vem contados la
 * tambem: refazer a conta aqui com `new Date()` compararia o relogio do navegador dele com o
 * carimbo da VPS, que e' a armadilha que a casa ja paga em outros lugares.
 *
 * ⚠️ `null` NAO vira traco: ausencia nao se distingue de inexistencia ([DA-468]), e num campo
 * sobre envio o traco leria como "nao sei". Quem nunca recebeu recebe a frase por extenso.
 */
function ultimoEnvioEmPalavras(data: string | null, dias: number | null): string {
  if (!data || dias === null) return 'nunca recebeu fly';
  if (dias <= 0) return data + ' · hoje';
  return data + ' · há ' + contar(dias, 'dia');
}

/**
 * O motivo de um contato ter aberto DESMARCADO na edicao, em palavras — pedido dele em 24/09/2026.
 *
 * Le o registro que a montagem da fila grava (migration 0296). As quatro respostas possiveis:
 * a caixa foi tirada, a regra o segurava naquele dia (e hoje ja nao segura, senao ele estaria em
 * "Ficam de fora"), ele nao estava na etiqueta quando a fila foi montada, ou a campanha e'
 * anterior ao registro. ⚠️ "desmarcado" nao diz QUEM: a tela ja reabriu desmarcado quem estava
 * descansando (o Raul), entao afirmar "voce desmarcou" poderia ser falso.
 */
function motivoDoDesmarcado(
  reg: { fora: Record<string, { m: string; d: string; u?: string | null }> | null; montadaEm: string | null } | null,
  pessoa: string,
  excluidos: Array<{ motivo: string; texto: string }>,
): string {
  if (!reg?.fora) return 'motivo não registrado (fila montada antes de 24/09)';
  const e = reg.fora[pessoa];
  if (!e) return 'não estava nas etiquetas em ' + (reg.montadaEm ?? '?') + ' — entrou depois';
  if (e.m === 'desmarcado') return 'desmarcado ao salvar em ' + e.d;
  if (e.m === 'ja_recebeu_fly') {
    return 'de fora em ' + e.d + ': recebeu fly em ' + (e.u ?? '?') + ' — agora está livre';
  }
  if (e.m === 'nunca_falou') return 'de fora em ' + e.d + ': nunca tinha falado com a loja';
  const texto = excluidos.find((x) => x.motivo === e.m)?.texto ?? e.m;
  return 'de fora em ' + e.d + ': ' + texto;
}

/**
 * Uma linha das duas listas. Sem `onToggle` a linha nao tem caixa — e' o que separa "voce pode
 * decidir isto" de "isto esta decidido".
 *
 * ⛔ Mora FORA do componente de proposito: definida dentro do render, ela e' um tipo novo a cada
 * render e o React desmonta e remonta a lista inteira — com 324 contatos (o tamanho da etiqueta
 * `cristina`), digitar no filtro travaria a cada tecla.
 */
/**
 * Abre a conversa daquele numero no Atendimento, em ABA NOVA — pedido dele em 11/09/2026
 * ("para acessar direto, será muito útil para verificações").
 *
 * ⛔ **Aba nova, e nao `navigate`.** A Gestao de Vendas abre a conversa na MESMA aba ([DA-672]),
 * e ali isso e' de graca: a tela e' uma lista. Aqui ele esta com uma campanha MONTADA — nome,
 * fly, etiqueta e a selecao contato a contato — e trocar de rota joga tudo fora. Conferir um
 * contato nao pode custar a montagem.
 *
 * ⚠️ **Sem o `noopener` no 3o argumento** ([DA-572]): com ele o `window.open` devolve `null`
 * SEMPRE, e o idioma de fallback da casa dispararia a cada clique — abrindo em aba nova E por
 * cima desta. A protecao vem do `opener = null` na mao.
 */
function abrirConversaEmNovaAba(chave: string, nome: string | null) {
  // ⚠️ `voltar` + `rotulo` sao o que desenha a faixa "Voltar para ..." no Atendimento. Eu os
  // tinha omitido achando que nao faziam sentido em aba nova; ele cobrou (11/09/2026), e estava
  // certo: a aba nova tambem e' um lugar de onde se sai, e sem a faixa ela vira um beco.
  //
  // ⛔ O rotulo diz o DESTINO REAL, que e' a Gestao de Vendas — nunca "a campanha". Voltar nao
  // remonta a campanha (ela ficou viva na aba de origem); prometer isso seria o texto de UI
  // afirmando o que o botao nao faz ([DA-639]).
  // ⛔ `voltar=fechar`, nao um caminho: a aba e' NOVA, entao navegar abriria uma SEGUNDA copia da
  // Gestao de Vendas — e foi isso que ele relatou em 11/09/2026 ("esta voltando para a aba
  // Contatos"). Fechar a aba devolve a de origem, onde a campanha montada continua viva. So' ai
  // o rotulo "a campanha" e' verdade.
  const q = new URLSearchParams({
    telefone: chave,
    inbox: 'atendimento',
    voltar: 'fechar',
    rotulo: 'a campanha',
  });
  if (nome) q.set('nome', nome);
  const aba = window.open(`/atendimento?${q.toString()}`, '_blank');
  if (aba) aba.opener = null;
}

/** O motivo do desmarcado, no espaco livre da linha — em texto, porque cor ele nao separa. */
function MotivoDesmarcado({ texto }: { texto: string }) {
  return (
    <span className="truncate" title={texto} style={{ color: 'var(--text-muted)', fontStyle: 'italic', marginLeft: 4 }}>
      {texto}
    </span>
  );
}

function LinhaContato({
  nomeContato, chave, fotoUrl, marcado, onToggle, riscarDesmarcado, semWhatsApp,
  destacado, onAbriuConversa, ultimoEnvio, diasUltimoEnvio, etiquetasDaLinha, motivoDesmarcado, onExcluir,
}: {
  /**
   * Lixeira — so' nas linhas de numero que nao entrega, no lugar do botao de conversa (que ali nao
   * existe). Pedido dele em 24/09/2026: investigar e, sem conserto, apagar o contato de vez.
   */
  onExcluir?: () => void;
  /** Por que esta linha abriu desmarcada na edicao (`motivoDoDesmarcado`). Pedido dele, 24/09/2026. */
  motivoDesmarcado?: string;
  /**
   * Em quais etiquetas da campanha esta pessoa esta — pedido dele em 24/09/2026, no espaco entre
   * o nome e a data. A cor vem do cadastro que o modal ja recebe por prop (nunca do contexto,
   * que so' e' preenchido pelo "Gerenciar etiquetas" — [DA-737]).
   */
  etiquetasDaLinha?: Etiqueta[];
  nomeContato: string | null;
  chave: string;
  fotoUrl?: string | null;
  marcado: boolean;
  onToggle?: () => void;
  /** `DD/MM` do ultimo fly; `null` quando nunca recebeu. Pedido dele em 21/09/2026. */
  ultimoEnvio?: string | null;
  diasUltimoEnvio?: number | null;
  /** Numero que o WhatsApp nao alcanca — a tela nao oferece o que ja sabe que nao abre. */
  semWhatsApp?: boolean;
  /**
   * O contato cuja conversa ele acabou de abrir — pedido dele em 11/09/2026. Conferindo 54
   * linhas uma a uma, voltar da aba do chat sem saber onde parou obriga a recomecar a leitura.
   * E' o mesmo recibo do gesto que a lista de etiquetas ganhou hoje.
   */
  destacado?: boolean;
  onAbriuConversa?: () => void;
  /**
   * ⚠️ So' na lista de cima. Ali desmarcado significa *"eu tirei este"*, e o risco e' o retorno
   * do gesto dele. Na lista de FORA todo mundo nasce desmarcado por decisao do sistema, e riscar
   * os 16 faria o unico resgatado parecer a linha normal — o risco viraria enfeite e, pior,
   * esconderia qual e' a marca que importa naquela lista.
   */
  riscarDesmarcado?: boolean;
}) {
  return (
    <label
      className="flex items-center gap-2 px-2 py-1 text-xs"
      style={{
        cursor: onToggle ? 'pointer' : 'default',
        opacity: onToggle ? 1 : 0.75,
        // A letra volta junto com o fundo: o texto herda a cor do tema, que no escuro e' clara
        // e sumiria no amarelo.
        ...(destacado ? { backgroundColor: '#fde68a', color: '#000', borderRadius: 4 } : null),
      }}
    >
      {onToggle ? (
        <input type="checkbox" checked={marcado} onChange={onToggle} />
      ) : (
        <span style={{ width: 13, display: 'inline-block' }} />
      )}
      {/* O rosto do cliente. `Avatar` cai nas iniciais sozinho quando nao ha foto (ou quando a
          URL do WhatsApp ja venceu), entao a coluna nunca fica um buraco. */}
      <Avatar nome={nomeContato || '?'} fotoUrl={fotoUrl ?? null} tamanho={24} />
      {/* Com a coluna de etiqueta, o nome ganha largura FIXA pra os selos formarem uma coluna
          alinhada logo depois dele — que e' onde ele desenhou no print. 230px cabe o maior nome
          das 4 etiquetas medidas em 24/09/2026 (224px); o `truncate` cobre o resto. */}
      <span
        className={etiquetasDaLinha ? 'truncate' : 'flex-1 truncate'}
        style={{
          textDecoration: riscarDesmarcado && onToggle && !marcado ? 'line-through' : undefined,
          ...(etiquetasDaLinha ? { flex: '0 0 230px' } : null),
        }}
      >
        {nomeContato || SEM_NOME}
      </span>
      {etiquetasDaLinha && (
        <span className="flex flex-1 items-center gap-1" style={{ minWidth: 0 }}>
          {etiquetasDaLinha.map((e) => (
            <BadgeEtiqueta key={e.id} nome={e.nome} cor={e.cor || '#e2e8f0'} apelido={e.apelido} />
          ))}
          {motivoDesmarcado && <MotivoDesmarcado texto={motivoDesmarcado} />}
        </span>
      )}
      {!etiquetasDaLinha && motivoDesmarcado && (
        <span className="flex flex-1 items-center" style={{ minWidth: 0 }}>
          <MotivoDesmarcado texto={motivoDesmarcado} />
        </span>
      )}
      {/* O ultimo fly que saiu pra esta pessoa. Fica ao lado do nome, que e' onde ele apontou no
          print — e antes do telefone, pra nao separar o numero do botao que o abre. */}
      <span
        style={{
          color: destacado ? '#78350f' : 'var(--text-muted)',
          whiteSpace: 'nowrap', flex: '0 0 auto',
          fontStyle: ultimoEnvio ? undefined : 'italic',
        }}
      >
        {ultimoEnvioEmPalavras(ultimoEnvio ?? null, diasUltimoEnvio ?? null)}
      </span>
      <span
        className="tabular-nums"
        style={{ color: destacado ? '#78350f' : 'var(--text-muted)' }}
      >
        {telefoneLegivel(chave)}
      </span>
      {!semWhatsApp && (
        // ⚠️ `preventDefault` + `stopPropagation` sao OBRIGATORIOS: a linha inteira e' um
        // `<label>`, entao qualquer clique dentro dela alterna a caixa. Sem isso, conferir um
        // contato o DESMARCARIA da campanha — e o estrago sairia calado, porque a aba nova
        // rouba a atencao justamente no instante em que a marca muda.
        <button
          type="button"
          title="Abrir a conversa no Atendimento (aba nova)"
          aria-label={`Abrir a conversa de ${nomeContato || telefoneLegivel(chave)} no Atendimento`}
          onClick={(ev) => {
            ev.preventDefault();
            ev.stopPropagation();
            onAbriuConversa?.();
            abrirConversaEmNovaAba(chave, nomeContato);
          }}
          style={{
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            width: 22, height: 22, borderRadius: 6, flex: '0 0 auto',
            border: '1px solid var(--border)', background: 'var(--panel-bg)',
            color: 'var(--primary)', cursor: 'pointer',
          }}
        >
          <MessageCircle size={13} />
        </button>
      )}
      {semWhatsApp && onExcluir && (
        // Mesmos `preventDefault` + `stopPropagation` do botao de conversa: a linha e' um `<label>`.
        <button
          type="button"
          title="Apagar este contato de vez (número que não entrega)"
          aria-label={`Apagar o contato ${nomeContato || telefoneLegivel(chave)}`}
          onClick={(ev) => {
            ev.preventDefault();
            ev.stopPropagation();
            onExcluir();
          }}
          style={{
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            width: 22, height: 22, borderRadius: 6, flex: '0 0 auto',
            border: '1px solid var(--border)', background: 'var(--panel-bg)',
            color: '#dc2626', cursor: 'pointer',
          }}
        >
          <Trash2 size={13} />
        </button>
      )}
    </label>
  );
}

/** Uma linha de "quem ja recebeu" — serve a lista da campanha e a lista do dia. */
interface Recebeu {
  id: number;
  nome: string | null;
  foto_url: string | null;
  chave: string;
  hora: string | null;
  /** So' na lista da campanha: enviado, pulado ou erro — e o motivo, quando nao saiu. */
  status?: string;
  motivo?: string | null;
  min_desde_anterior?: number | null;
  /** So' na lista do dia: por qual porta saiu (`fly`, `fly_manual`, `fly_campanha`). */
  tipo?: string;
  /** So' no `fly_manual`: QUEM mandou. Vem de cruzamento por tempo — pode faltar. */
  por_quem?: string | null;
  dia?: string | null;
}

/** O nome de cada porta, como ele le. O `tipo` cru nao significa nada pra quem opera. */
const PORTA: Record<string, string> = {
  fly: 'automático',
  fly_manual: 'no chat',
  fly_campanha: 'campanha',
};

/**
 * Por onde — e por QUEM — aquele fly saiu. Vira o CABECALHO do grupo, nunca coluna de linha.
 *
 * ⚠️ No manual o nome da vendedora vem na frente, porque foi exatamente isso que ele pediu:
 * *"gostaria de visualizar os contatos que receberam por intermedio dos vendedores"*. Sem o
 * nome, a coluna dizia so' "a vendedora, no chat" — verdade, e inutil pra saber QUAL.
 * ⚠️ Quando o cruzamento nao acha ninguem, cai no rotulo generico em vez de inventar um nome.
 */
function porOndeSaiu(l: Recebeu): string {
  const porta = PORTA[l.tipo ?? ''] ?? l.tipo ?? '';
  if (l.tipo === 'fly_manual') return l.por_quem ? 'por ' + l.por_quem + ', ' + porta : 'por uma vendedora, ' + porta;
  if (l.tipo === 'fly_campanha') return 'pela campanha';
  return 'pelo envio ' + porta;
}

/**
 * A lista do dia AGRUPADA por quem mandou — corte dele em 21/09/2026: *"esta confuso. As
 * mensagens enviadas por usuarios precisam aparecer identificada o usuario e separadas das
 * mensagens por campanha"*.
 *
 * ⛔ Ordenar so' por hora misturava as duas origens linha a linha, e a unica coisa que as
 * separava era uma coluna na ponta direita. Quem le a lista quer saber *quanto da cota foi
 * gasto por quem* — e essa pergunta se responde por GRUPO, nao varrendo uma coluna.
 *
 * ⚠️ Mesma forma da lista "Ficam de fora" logo ao lado, que ele ja usa: cabecalho com a
 * contagem, linhas embaixo. Padrao visual so' vale se a proxima lista nascer igual.
 */
function agruparPorOrigem(linhas: Recebeu[]): Array<{ rotulo: string; linhas: Recebeu[] }> {
  const mapa = new Map<string, { rotulo: string; linhas: Recebeu[] }>();
  for (const l of linhas) {
    const rotulo = porOndeSaiu(l);
    const g = mapa.get(rotulo) ?? { rotulo, linhas: [] };
    g.linhas.push(l);
    mapa.set(rotulo, g);
  }
  return [...mapa.values()].sort((a, b) => b.linhas.length - a.linhas.length);
}

/**
 * A lista da CAMPANHA agrupada por DIA — corte dele em 22/09/2026 ([DA-737]): *"deve exibir
 * todas as mensagens enviadas pela campanha, ordenados por data e hora, assim vai deixar mais
 * claro o que esta acontecendo"*.
 *
 * ⚠️ Ela JA exibia todas e JA vinha ordenada (`enviado_em DESC` na rota, sem limite) — medido
 * na tela viva: 35 linhas dentro de uma caixa de 260px pra 1.015px de conteudo, **3,9 telas de
 * rolagem**. O que faltava nao era dado, era CABER: as 9 linhas visiveis eram todas do mesmo
 * dia, entao a campanha parecia ter comecado hoje. A duvida dele nasceu dai ("20 por dia, dois
 * dias, nao seriam 40?") e a tela nao tinha como responder.
 *
 * ⛔ A ordem segue MAIS RECENTE PRIMEIRO — escolha dele entre as duas, contra a cronologica:
 * a gaveta abre respondendo *onde a campanha esta agora*, sem rolar.
 *
 * ⚠️ Nao ordena nem reordena nada: o Map preserva a ordem de insercao, e a rota ja entrega
 * `enviado_em DESC NULLS LAST` — entao os dias saem do mais novo pro mais velho e quem nao
 * saiu cai no fim sozinho. Ordenar de novo aqui seria uma segunda regra pra divergir da
 * primeira.
 */
function agruparPorDia(linhas: Recebeu[]): Array<{ rotulo: string; linhas: Recebeu[] }> {
  const mapa = new Map<string, { rotulo: string; linhas: Recebeu[] }>();
  for (const l of linhas) {
    // Linha que nao saiu nao tem data — e' o grupo do fim, com o motivo em cada linha.
    const rotulo = l.dia ? 'em ' + l.dia : 'nao sairam';
    const g = mapa.get(rotulo) ?? { rotulo, linhas: [] };
    g.linhas.push(l);
    mapa.set(rotulo, g);
  }
  return [...mapa.values()];
}

/**
 * A gaveta de "quem ja recebeu" — pedido dele em 21/09/2026, com o print da linha da campanha:
 * *"pensei em criar um sinal de + que clicando expandiria para mostrar os contatos enviados"*.
 *
 * ⛔ Reusa a `LinhaContato`, nao redesenha: e' a mesma pergunta ("quem e' esta pessoa?") no
 * mesmo modal, e duas formas de desenhar contato aqui dentro viram duas coisas de manter.
 *
 * ⚠️ O que NAO saiu vai junto, com o motivo — linha que deixa a fila sem mensagem precisa de
 * onde ser auditada, senao o placar termina com um numero que ninguem consegue explicar.
 */
function GavetaRecebeu({ linhas, carregando, vazio, agrupar }: {
  linhas: Recebeu[] | null;
  carregando: boolean;
  vazio: string;
  /**
   * O EIXO do agrupamento: ligado, agrupa por ORIGEM (a lista do dia, que mistura as portas);
   * desligado, por DIA (a lista da campanha, que e' toda de uma origem so' e atravessa dias).
   */
  agrupar?: boolean;
}) {
  const caixaRef = useRef<HTMLDivElement | null>(null);
  const [alturaLivre, setAlturaLivre] = useState<number | null>(null);

  /**
   * ⛔ A altura da lista da campanha se MEDE, nao se escreve ([DA-704]). A primeira versao usava
   * `60vh` e o par de janelas pegou o defeito antes dele: em 732px de altura sobrava 11px ate o
   * rodape, mas em **600px a lista invadia o rodape em 41px** — constante em CSS reserva folga
   * proporcional, e o que esta ACIMA da caixa (cabecalho do modal, abas, linha da campanha) tem
   * altura FIXA. A conta certa parte de onde a caixa comeca, que so' o runtime sabe.
   *
   * ⚠️ O topo muda sozinho: expandir a segunda campanha da lista desce a caixa. Por isso a
   * medicao roda tambem quando as linhas trocam, nao so' no `resize`.
   */
  useEffect(() => {
    if (agrupar) return;
    const medir = () => {
      const el = caixaRef.current;
      if (!el) return;
      const topo = el.getBoundingClientRect().top;
      const rodape = el.closest('.modal-conteudo')?.querySelector('.modal-footer');
      const fundo = rodape ? rodape.getBoundingClientRect().top : window.innerHeight;
      // O piso evita a caixa sumir em janela muito baixa; se nem ele couber, quem rola e' o
      // `.modal-body`, que ja e' `overflow-y: auto`.
      setAlturaLivre(Math.max(140, Math.floor(fundo - topo - 12)));
    };
    medir();
    window.addEventListener('resize', medir);
    return () => window.removeEventListener('resize', medir);
  }, [agrupar, linhas]);

  if (carregando && !linhas) {
    return (
      <div className="text-xs px-2 py-2 flex items-center gap-2" style={{ color: 'var(--text-muted)' }}>
        <Loader2 size={13} className="animate-spin" /> carregando…
      </div>
    );
  }
  if (!linhas || linhas.length === 0) {
    return <div className="text-xs px-2 py-2" style={{ color: 'var(--text-muted)' }}>{vazio}</div>;
  }
  const umaLinha = (l: Recebeu) => (
        // ⛔ Nada de `flex-1` no nome. Ate 21/09/2026 ele estava assim, e como este modal e' de
        // TELA CHEIA o nome empurrava telefone e hora pra outra ponta — quase 1.400px de vazio no
        // meio, obrigando a varrer a linha com o olho. Ele pediu tudo perto do nome, e isso quer
        // dizer COLUNAS DE LARGURA FIXA, agrupadas a esquerda.
        <div key={l.id} className="flex items-center gap-3 px-2 py-1 text-xs">
          <Avatar nome={l.nome || '?'} fotoUrl={l.foto_url} tamanho={22} />
          {/* As larguras saem da MEDICAO do texto real, nao de chute: o nome mais longo da base
              de contatos pede ~210px nesta fonte. `truncate` cobre a excecao. */}
          <span className="truncate" style={{ width: 230, flex: '0 0 auto' }}>
            {l.nome || SEM_NOME}
          </span>
          <span
            className="tabular-nums"
            style={{ color: 'var(--text-muted)', whiteSpace: 'nowrap', width: 108, flex: '0 0 auto' }}
          >
            {telefoneLegivel(l.chave)}
          </span>
          <span
            className="tabular-nums"
            style={{ color: 'var(--text-muted)', whiteSpace: 'nowrap', width: 150, flex: '0 0 auto' }}
          >
            {l.hora ? (l.dia ? l.dia + ' ' : '') + l.hora : '—'}
            {/* O intervalo ate o envio anterior: e' o que mostra o gotejo acontecendo. */}
            {typeof l.min_desde_anterior === 'number' && ' · ' + l.min_desde_anterior + ' min'}
          </span>
          {/* O motivo de quem NAO recebeu fica colado na linha dele, nunca num rodape solto. */}
          {l.status && l.status !== 'enviado' && (
            <span style={{ color: 'var(--text-muted)', fontStyle: 'italic', whiteSpace: 'nowrap' }}>
              {l.motivo || l.status}
            </span>
          )}
          {/* ⛔ A ORIGEM nao vem mais aqui: ela virou o cabecalho do grupo. Repetir "campanha" em
              toda linha era papel de parede, e era o que deixava as duas origens misturadas. */}
        </div>
  );

  // As duas listas desenham GRUPOS; muda o EIXO (a origem, no dia; a data, na campanha) e a
  // altura. ⚠️ A da campanha e' a longa — 35 linhas em 21/09 — e por isso ganhou mais espaco:
  // a caixa de 260px mostrava 9 delas, todas do mesmo dia, e escondia que a campanha vinha de
  // ontem ([DA-737]). So' UMA gaveta de campanha abre por vez (`gavetaCampanha === c.id`),
  // entao a altura maior nao empilha com outra.
  const grupos = agrupar ? agruparPorOrigem(linhas) : agruparPorDia(linhas);

  return (
    <div ref={caixaRef} style={{ maxHeight: agrupar ? 320 : (alturaLivre ?? 260), overflowY: 'auto' }}>
      {grupos.map((g) => (
        <div key={g.rotulo}>
          {/* Mesmo cabecalho da lista "Ficam de fora": contagem em destaque + o rotulo.
              ⚠️ `sticky` so' na lista da campanha: com 3 a 4 telas de rolagem, cabecalho que
              sobe deixa quem esta no meio sem saber de que dia e' a linha que ele esta lendo. */}
          <div
            className="px-2 py-1 text-xs font-semibold flex items-center gap-1"
            style={{
              backgroundColor: 'var(--grid-header-bg)',
              color: 'var(--grid-header-fg)',
              ...(agrupar ? null : { position: 'sticky' as const, top: 0, zIndex: 1 }),
            }}
          >
            <span className="tabular-nums">{g.linhas.length}</span>
            <span style={{ fontWeight: 400 }}>{g.rotulo}</span>
          </div>
          {g.linhas.map(umaLinha)}
        </div>
      ))}
    </div>
  );
}

/**
 * A aba CONFIGURAÇÕES — os parametros de envio, pedido dele em 21/09/2026.
 *
 * O que ela resolve, e por que os tres campos moram juntos: eles so' fazem sentido em conjunto.
 * Teto sem intervalo mente (um teto de 20 com 50 min entre envios nunca e' atingido), e
 * intervalo sem janela nao entrega o que ele queria — *"enviar na parte da manha o retorno tende
 * a ser melhor"*. A CONTA ao lado dos campos e' o que liga os tres: ela diz, enquanto ele digita,
 * quantos envios cabem de verdade.
 *
 * ⛔ Fora do componente pai de proposito (mesmo motivo do `LinhaContato`): definida dentro do
 * render, ela seria um tipo novo a cada tecla e os campos perderiam o foco enquanto ele digita.
 */
function AbaParametros({
  config, setConfig, minutosLojaHoje, gravado, salvando, onSalvar,
}: {
  config: ParametrosEnvio | null;
  setConfig: (p: ParametrosEnvio) => void;
  minutosLojaHoje: number;
  gravado: ParametrosEnvio | null;
  salvando: boolean;
  onSalvar: () => void;
}) {
  if (!config) {
    return (
      <div className="text-xs px-2 py-3" style={{ color: 'var(--text-muted)' }}>
        Carregando os parâmetros…
      </div>
    );
  }

  const mudar = (p: Partial<ParametrosEnvio>) => setConfig({ ...config, ...p });

  // A janela EFETIVA: ligada, ela so' encolhe o expediente; desligada, e' o expediente inteiro.
  const minutosJanela = config.janela_ativa
    ? Math.min(minutosEntreHoras(config.janela_inicio, config.janela_fim), minutosLojaHoje)
    : minutosLojaHoje;
  const janelaInvertida = config.janela_ativa
    && minutosEntreHoras(config.janela_inicio, config.janela_fim) <= 0;
  const parInvertido = config.intervalo_max < config.intervalo_min;

  // ⛔ Fora da grade a tela RECUSA (o Salvar trava e a faixa diz o porque) — nao corrige o
  // numero por baixo do pano, que foi o defeito que ele cortou em 21/09/2026.
  const foraDaGrade = (n: number) => n < INTERVALO_MINIMO || n % PASSO_INTERVALO !== 0;
  const intervaloForaDaGrade = foraDaGrade(config.intervalo_min) || foraDaGrade(config.intervalo_max);
  // O intervalo MAIOR produz o menor numero de envios, e vice-versa.
  const cabemMin = cabemNaJanela(minutosJanela, config.intervalo_max);
  const cabemMax = cabemNaJanela(minutosJanela, config.intervalo_min);
  // ⚠️ O aviso que fez a aba existir: teto que o ritmo nao alcanca. Ele NAO e' erro — e' a tela
  // contando o que o motor faz, porque ate 21/09/2026 a estimativa de "N dias" dividia pelo teto
  // e subestimava a duracao de toda campanha grande.
  const tetoInalcancavel = minutosJanela > 0 && config.teto_diario > cabemMax;

  const alterado = !!gravado && (
    gravado.teto_diario !== config.teto_diario
    || gravado.intervalo_min !== config.intervalo_min
    || gravado.intervalo_max !== config.intervalo_max
    || gravado.janela_ativa !== config.janela_ativa
    || gravado.janela_inicio !== config.janela_inicio
    || gravado.janela_fim !== config.janela_fim
  );
  const impedimento = intervaloForaDaGrade
    ? 'O intervalo é em minutos inteiros, a partir de ' + INTERVALO_MINIMO + '.'
    : janelaInvertida
      ? 'A janela termina antes de começar — nada seria enviado.'
      : parInvertido
        ? 'O intervalo máximo não pode ser menor que o mínimo.'
        : null;

  const estiloCampo = {
    backgroundColor: 'var(--panel-bg)', borderColor: 'var(--border)', color: 'var(--text)',
  };

  return (
    <div style={{ flex: '1 1 auto', minHeight: 0, overflowY: 'auto' }}>
      <div className="flex flex-col gap-4" style={{ maxWidth: 620 }}>
        <p className="text-xs" style={{ color: 'var(--text-muted)' }}>
          Estes três valem para <strong>todas</strong> as campanhas ao mesmo tempo — o que protege o
          número da loja é o total que sai, não o de cada campanha.
        </p>

        {/* ── TETO ── */}
        <label className="flex flex-col gap-1">
          <span className="text-xs font-semibold">Teto por dia</span>
          <input
            type="number"
            min={0}
            max={200}
            value={config.teto_diario}
            onChange={(ev) => mudar({ teto_diario: Number(ev.target.value) })}
            className="w-24 px-2 py-1 rounded border text-right tabular-nums"
            style={estiloCampo}
          />
          <span className="text-xs" style={{ color: 'var(--text-muted)' }}>
            Conta só os envios da campanha — o fly que a vendedora manda no chat não gasta vaga.
          </span>
        </label>

        {/* ── INTERVALO ── */}
        <div className="flex flex-col gap-1">
          <span className="text-xs font-semibold">Intervalo entre um envio e o outro</span>
          <div className="flex items-center gap-2 text-xs">
            de
            <input
              type="number"
              min={INTERVALO_MINIMO}
              step={PASSO_INTERVALO}
              value={config.intervalo_min}
              onChange={(ev) => mudar({ intervalo_min: Number(ev.target.value) })}
              className="w-20 px-2 py-1 rounded border text-right tabular-nums"
              style={estiloCampo}
            />
            a
            <input
              type="number"
              min={INTERVALO_MINIMO}
              step={PASSO_INTERVALO}
              value={config.intervalo_max}
              onChange={(ev) => mudar({ intervalo_max: Number(ev.target.value) })}
              className="w-20 px-2 py-1 rounded border text-right tabular-nums"
              style={estiloCampo}
            />
            minutos
          </div>
          {/* ⚠️ Este texto DESCREVE o motor. Ele dizia "de 5 em 5 minutos" enquanto o tique era de
              5 min; trocar o relogio sem trocar a frase deixaria na tela uma regra que nao existe
              mais — e o operador obedece o texto ([DA-639]). Desde 07/10/2026 o tique e' de 1 min. */}
          <span className="text-xs" style={{ color: 'var(--text-muted)' }}>
            O sistema sorteia um valor dentro dessa faixa a cada envio — intervalo fixo desenha
            padrão de relógio. Para não variar, ponha o mesmo número nos dois campos. Vale qualquer
            número inteiro de minutos, a partir de {INTERVALO_MINIMO}: o sistema confere a cada
            minuto se já deu a hora.
          </span>
        </div>

        {/* ── JANELA ── */}
        <div className="flex flex-col gap-1">
          <span className="text-xs font-semibold">Faixa de horário</span>
          <Interruptor
            ligado={config.janela_ativa}
            onChange={(v) => mudar({ janela_ativa: v })}
            rotuloLigado="Só numa faixa do dia"
            rotuloDesligado="Enquanto a loja estiver aberta"
            ajuda={config.janela_ativa
              ? 'Fora da faixa nada sai, mesmo com a loja aberta e a fila cheia.'
              : 'O gotejo usa todo o expediente, que é o que ele sempre fez.'}
          />
          {config.janela_ativa && (
            <div className="flex items-center gap-2 text-xs mt-1">
              das
              <input
                type="time"
                value={config.janela_inicio}
                onChange={(ev) => mudar({ janela_inicio: ev.target.value })}
                className="px-2 py-1 rounded border tabular-nums"
                style={estiloCampo}
              />
              às
              <input
                type="time"
                value={config.janela_fim}
                onChange={(ev) => mudar({ janela_fim: ev.target.value })}
                className="px-2 py-1 rounded border tabular-nums"
                style={estiloCampo}
              />
            </div>
          )}
        </div>

        {/* ── A CONTA: é ela que liga os três campos ── */}
        <div
          className="rounded border px-3 py-2 text-xs flex flex-col gap-1"
          style={{ borderColor: 'var(--border)', backgroundColor: 'var(--panel-bg)' }}
        >
          {minutosLojaHoje === 0 ? (
            <span>A loja não abre hoje — nada sai até o próximo dia de expediente.</span>
          ) : janelaInvertida || intervaloForaDaGrade ? (
            // Sem conta enquanto o valor não vale: imprimi-la com o número corrigido faria a
            // tela responder por um intervalo que ela está recusando.
            <span>Corrija o que está marcado abaixo para ver a conta.</span>
          ) : (
            <>
              <span>
                Nesse ritmo cabem{' '}
                <strong className="tabular-nums" style={{ color: 'var(--num-destaque)' }}>
                  {cabemMin === cabemMax ? contar(cabemMin, 'envio') : cabemMin + ' a ' + cabemMax + ' envios'}
                </strong>{' '}
                por dia — {contar(minutosJanela, 'minuto')}
                {config.janela_ativa ? ' de faixa' : ' de loja aberta hoje'}.
              </span>
              {tetoInalcancavel && (
                <span style={{ color: 'var(--text-muted)' }}>
                  O teto de {config.teto_diario} não chega a ser atingido nesse ritmo — quem manda
                  no volume passa a ser o intervalo.
                </span>
              )}
            </>
          )}
        </div>

        {impedimento && (
          <div
            className="rounded px-3 py-2 text-xs"
            style={{ backgroundColor: '#f97316', color: '#000' }}
          >
            {impedimento}
          </div>
        )}

        <div className="flex items-center gap-2">
          <button
            type="button"
            className="btn-primario"
            disabled={!alterado || !!impedimento || salvando}
            onClick={onSalvar}
          >
            {salvando ? 'Salvando…' : 'Salvar'}
          </button>
          {/* Botao apagado DIZ por que — beco sem saida nao e' interface limpa. */}
          {!alterado && !impedimento && (
            <span className="text-xs" style={{ color: 'var(--text-muted)' }}>
              Nada mudou desde o que está gravado.
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

// Nao e' etiqueta cadastrada: e' quem nao tem nenhuma etiqueta visivel (migration 0302). Cinza de
// proposito — as cores da paleta sao das etiquetas reais, e esta nao classifica ninguem.
const ETIQUETA_SEM: Etiqueta = { id: SEM_ETIQUETA_ID, nome: SEM_ETIQUETA_NOME, cor: '#94a3b8', apelido: null };

// A grade da aba Em andamento (06/10/2026). Derivada da cor do TEXTO: acompanha o tema (escura no
// claro, clara no escuro) — o `--border` some sobre o fundo do modal.
const GRADE_CAMPANHA = 'color-mix(in srgb, var(--text-color) 45%, transparent)';

/** Uma celula da grade: largura fixa (forma a coluna) ou `null` = a elastica, e a linha vertical a esquerda. */
function celulaCampanha(largura: number | null, alinhar: 'flex-start' | 'center' | 'flex-end', primeira = false): React.CSSProperties {
  return {
    display: 'flex', alignItems: 'center', justifyContent: alinhar,
    padding: '8px 10px', boxSizing: 'border-box',
    ...(largura ? { flex: '0 0 ' + largura + 'px', width: largura } : { flex: '1 1 auto', minWidth: 0 }),
    ...(primeira ? {} : { borderLeft: '1px solid ' + GRADE_CAMPANHA }),
  };
}

export function ModalCampanhaFly({ etiquetas: etiquetasCadastro, onFechar }: {
  etiquetas: Etiqueta[];
  onFechar: () => void;
}) {
  // O "Sem etiqueta" entra como a PRIMEIRA opcao da lista, com o id 0 (pedido dele, 28/09/2026 —
  // `SEM_ETIQUETA_ID`). Montado aqui uma vez, todo lugar da tela que le `etiquetas` (combo, selo,
  // coluna Etiqueta da previa, nome no aviso) passa a conhece-lo sem um caso especial por lugar.
  const etiquetas = useMemo(() => [ETIQUETA_SEM, ...etiquetasCadastro], [etiquetasCadastro]);
  const toast = useToast();
  const dialog = useDialog();
  // A aba interna tambem volta no F5 (mesmo pedido que reabre a tela, 23/09/2026). O que vem do
  // storage e' VALIDADO — valor estranho cai em 'nova'.
  const [vista, setVistaEstado] = useState<'nova' | 'andamento' | 'config'>(() => {
    try {
      const salvo = sessionStorage.getItem('campanha-fly:vista');
      return salvo === 'andamento' || salvo === 'config' ? salvo : 'nova';
    } catch { return 'nova'; }
  });
  const setVista = (v: 'nova' | 'andamento' | 'config') => {
    setVistaEstado(v);
    try { sessionStorage.setItem('campanha-fly:vista', v); } catch { /* so' nao lembra */ }
  };
  /**
   * O rascunho da aba Configuracoes. Fica separado do `painel` de proposito: enquanto ele digita,
   * a conta ao lado dos campos tem que acompanhar o que ESTA NA TELA, nao o que esta gravado —
   * senao ele mexe no intervalo e o "cabem N por dia" continua respondendo pelo valor antigo.
   */
  const [config, setConfig] = useState<ParametrosEnvio | null>(null);
  const [salvandoConfig, setSalvandoConfig] = useState(false);

  /**
   * As gavetas de "quem ja recebeu" (pedido dele, 21/09/2026). Uma por campanha, mais a do dia.
   *
   * ⚠️ O conteudo e' buscado no CLIQUE, nunca na abertura do modal: pendurar a lista no painel
   * faria toda abertura pagar consultas que ninguem esta olhando ([DA-627]).
   */
  const [gavetaCampanha, setGavetaCampanha] = useState<number | null>(null);
  /** A arte da campanha aberta em tamanho grande (clique na miniatura da lista). */
  const [flyAmpliado, setFlyAmpliado] = useState<{ url: string; nome: string } | null>(null);
  // A PREVIA da arte na lista, pra campanha que ainda nao mandou nada (pedido dele, 25/09/2026).
  // Chave = os produtos, nao a campanha: editar a campanha troca a previa sozinho.
  const [previasLista, setPreviasLista] = useState<Record<string, string | 'erro'>>({});
  const previasPedidas = useRef(new Set<string>());
  // ⚠️ Toda arte desta tela passa por ESTA fila, uma de cada vez: quem desenha e' o mesmo
  // Puppeteer do worker, e duas filas soltas (flys guardados + previas) ja seriam duas ao mesmo tempo.
  const filaArte = useRef<Promise<unknown>>(Promise.resolve());
  const desenharEmFila = useCallback((produtoIds: number[]) => {
    const vez = filaArte.current.catch(() => undefined).then(() => api.post<Arte>('/api/campanhas-fly/arte', { produto_ids: produtoIds }));
    filaArte.current = vez;
    return vez;
  }, []);
  /** A campanha cujo carrossel do Instagram esta aberto (23/09/2026). */
  const [carrosselDe, setCarrosselDe] = useState<number | null>(null);
  const [linhasCampanha, setLinhasCampanha] = useState<Recebeu[] | null>(null);
  const [gavetaDia, setGavetaDia] = useState(false);
  const [linhasDia, setLinhasDia] = useState<Recebeu[] | null>(null);
  const [carregandoGaveta, setCarregandoGaveta] = useState(false);

  const [flys, setFlys] = useState<FlySalvo[]>([]);
  // Lido UMA vez, na montagem — e' o que o F5 deixou ([CHAVE_RASCUNHO_PRODUTOS]).
  const [rascunhoLido] = useState(lerRascunhoProdutos);
  // Rascunho de EDICAO nao preenche o formulario de campanha nova: ele volta pela reabertura da
  // edicao (efeito da montagem, abaixo), senao os produtos piscariam numa campanha nova.
  const rascunhoInicial = rascunhoLido && rascunhoLido.editandoId === null ? rascunhoLido : null;
  const [flyId, setFlyId] = useState<number | null>(rascunhoInicial?.flyId ?? null);
  // Varias etiquetas desde 23/09/2026 (pedido dele): recebe quem esta em QUALQUER uma.
  const [etiquetaIds, setEtiquetaIds] = useState<number[]>([]);
  const temEtiqueta = etiquetaIds.length > 0;
  /**
   * A campanha que esta sendo EDITADA (pedido dele, 23/09/2026) — nula = criando uma nova. A
   * edicao usa o MESMO formulario: sao os mesmos campos, e duas telas divergiriam.
   */
  const [editando, setEditando] = useState<{ id: number; nome: string } | null>(null);
  /**
   * Quem esta na fila no momento de abrir a edicao. Consumido pela PRIMEIRA previa: ela e' quem
   * sabe a lista atual, e a selecao se monta a partir dela — marcado = esta na fila. Assim
   * salvar sem mexer deixa a fila igual, e quem entrou na etiqueta depois aparece DESMARCADO,
   * a vista, em vez de entrar sem ele ver.
   */
  const inicioEdicao = useRef<Map<string, boolean> | null>(null);
  /**
   * O registro de quem ficou de fora na ultima montagem (migration 0296). Consumido junto com o
   * `inicioEdicao`, pela primeira previa, pra montar o `motivoAbertura`.
   */
  const registroEdicao = useRef<{ fora: CampanhaParaEditar['fora_na_montagem']; montadaEm: string | null } | null>(null);
  /**
   * POR QUE cada contato abriu desmarcado na edicao — pedido dele em 24/09/2026 (*"exibir o
   * motivo, por que foi desmarcado"*), depois de o Raul reabrir desmarcado sem ninguem ter tirado.
   * ⚠️ So' quem abriu desmarcado ganha motivo: quem ELE desmarca durante a edicao nao tem registro,
   * e o "nao esta no registro" daria "entrou na etiqueta depois" — mentira sobre um gesto dele.
   */
  const [motivoAbertura, setMotivoAbertura] = useState<Map<string, string>>(new Map());
  /** O formulario como a edicao ABRIU — Salvar so' acende quando algo difere disto. */
  // ⚠️ ESTADO, nao ref: ela e' tirada num efeito DEPOIS do render, e um ref ali nao redesenha —
  // o botao ficava com a conta do render anterior ate outra coisa mudar (na reabertura por F5,
  // nada mais muda, e o Salvar ficava apagado com a alteracao na tela).
  const [assinaturaInicial, setAssinaturaInicial] = useState<string | null>(null);
  /** A edicao reaberta por F5 trouxe produtos diferentes dos gravados — conta como alteracao. */
  const restauradoDiferente = useRef(false);
  /**
   * A chave do contato cuja conversa ele abriu por ultimo — o lugar onde ele parou de conferir.
   * ⚠️ NAO precisa ser zerada ao trocar de etiqueta: a lista nova nao contem esta chave, entao o
   * destaque simplesmente nao acha onde pousar.
   */
  const [conversaAberta, setConversaAberta] = useState<string | null>(null);
  const [texto, setTexto] = useState('');
  const [incluirFrios, setIncluirFrios] = useState(false);
  const [nome, setNome] = useState('');
  // Data inicial do disparo (pedido dele, 25/09/2026) — nasce HOJE.
  const [iniciaEm, setIniciaEm] = useState(hojeISO);

  const [previa, setPrevia] = useState<Previa | null>(null);
  const [carregandoPrevia, setCarregandoPrevia] = useState(false);
  /** Refaz a previa sem mexer na selecao — depois de apagar um contato pela lixeira. */
  const [recargaPrevia, setRecargaPrevia] = useState(0);
  const [enviando, setEnviando] = useState(false);
  const [painel, setPainel] = useState<Painel | null>(null);
  // ⛔ A aba volta no F5 (sessionStorage, acima), mas o rascunho `config` so' nascia no CLIQUE da
  // aba — recarregar estando em Configuracoes deixava "Carregando os parametros..." pra sempre
  // (relato dele, 07/10/2026: "Bugou"). Quando o painel chega e a aba aberta e' a de config sem
  // rascunho, o rascunho nasce do gravado. So' com `config` nulo: nunca pisa no que ele digitou.
  useEffect(() => {
    if (vista === 'config' && config === null && painel) setConfig({ ...painel.parametros });
  }, [vista, config, painel]);

  // A SELECAO dele ([DA-714]). Guardo quem ele TIROU, nunca quem ficou: a lista nasce toda
  // marcada, e guardar os desmarcados faz o conjunto novo ja nascer certo quando a previa se
  // refaz. Os resgates sao o espelho — nascem vazios, porque a lista de fora nasce toda
  // desmarcada.
  const [desmarcados, setDesmarcados] = useState<Set<string>>(new Set());
  const [resgatados, setResgatados] = useState<Set<string>>(new Set());
  const [filtro, setFiltro] = useState('');

  // As artes, uma por fly guardado. `pedidas` e' ref e nao estado de proposito: entrar na lista
  // de dependencias do efeito que as busca faria ele recomecar a cada imagem que chega.
  const [artes, setArtes] = useState<Record<number, Arte | 'erro'>>({});
  const pedidas = useRef<Set<number>>(new Set());
  const [desenhando, setDesenhando] = useState<number | null>(null);

  // O texto so' nasce com o padrao enquanto ele nao tiver digitado nada — depois disso o campo
  // e' dele, e recarregar o painel nao pode apagar o que ele escreveu.
  const textoTocado = useRef(false);

  // ── SOMENTE TEXTO (decisao dele, 21/09/2026) ──────────────────────────────────────────────
  // Nasce DESLIGADO: toda campanha continua mandando a arte de sempre enquanto ele nao ligar.
  const [somenteTexto, setSomenteTexto] = useState(rascunhoInicial?.somenteTexto ?? false);
  // A lista AD-HOC (escolhida direto na campanha, decisao 2 — nao vem de fly guardado). Serve
  // pros dois lados: enquanto o modo texto esta ligado, e' a selecao inteira; desligado, so'
  // existe se sobrou algo de uma troca de modo (a truncagem da decisao 4).
  const [produtosAdHoc, setProdutosAdHoc] = useState<ProdutoEscolha[]>(rascunhoInicial?.produtos ?? []);
  /** A tela "Ordem dos produtos no fly" (pedido dele, 24/09/2026). */
  const [ordemAberta, setOrdemAberta] = useState(false);
  // ⛔ A PORTA do modo imagem (pedido dele, 21/09/2026). Ate hoje, campanha COM arte so' nascia
  // de fly guardado: ele digitou "CANO" no nome da campanha esperando buscar o produto, e a
  // busca nao existia deste lado — com UM fly guardado na biblioteca, uma oferta de cano exigia
  // sair, montar e guardar o fly antes. A busca abre no modo imagem tambem; o fly guardado vira
  // ATALHO, nao obrigacao. A quantidade segue a regra da arte (1 a 3, ou 12).
  // Vira `true` no primeiro toque no picker ad-hoc — antes disso, ligar/desligar o modo so'
  // espelha o fly guardado escolhido, sem criar uma combinacao nova.
  // (O `escolhendoProdutos` que abria o picker no modo imagem SAIU na [DA-743]: a busca fica
  // sempre a vista, junto com a lista de flys guardados.)
  const adHocTocado = useRef(rascunhoInicial?.adHocTocado ?? false);
  // Decisao 6: ao LIGAR com produto sem Descricao Comercial, a tela APONTA — nunca remove.
  // Desde a [DA-742] vale nos DOIS modos: a arte da campanha tambem exige a comercial.
  const [avisoDescricao, setAvisoDescricao] = useState<Array<{ id: number; descricao: string }>>([]);
  // Os produtos dos flys GUARDADOS que estao sem Descricao Comercial ([DA-742]). O fly guardado
  // nasceu no chat, onde a comercial nao e' exigida — entao ele pode trazer produto que a
  // campanha recusa, e a tela tem que dizer QUAL antes do clique em Criar.
  const [semComercialFlys, setSemComercialFlys] = useState<Set<number>>(new Set());
  // Decisao 4/5: ao DESLIGAR com lista grande demais pro fly com arte, ela trunca e AVISA.
  const [avisoTruncamento, setAvisoTruncamento] = useState<{ entram: number; fora: number } | null>(null);
  const [buscaAdHoc, setBuscaAdHoc] = useState('');
  const [produtosBuscaAdHoc, setProdutosBuscaAdHoc] = useState<ProdutoEscolha[]>([]);
  const [carregandoBuscaAdHoc, setCarregandoBuscaAdHoc] = useState(false);
  // A previa da mensagem SEM arte, vinda do servidor ([DA-591] — mesma peca do envio).
  const [mensagemTextoPrevia, setMensagemTextoPrevia] = useState<string | null>(null);
  const [carregandoMensagemTexto, setCarregandoMensagemTexto] = useState(false);
  const [erroMensagemTexto, setErroMensagemTexto] = useState<string | null>(null);
  // A arte de uma combinacao AD-HOC no modo imagem (sobra de um desligar-com-truncamento) —
  // `/arte` aceita `produto_ids` direto, sem precisar de um fly guardado.
  const [arteAdHoc, setArteAdHoc] = useState<Arte | 'erro' | null>(null);

  const flyEscolhido = flys.find((f) => f.id === flyId) ?? null;
  const arteEscolhida = flyId !== null ? artes[flyId] : undefined;

  const carregarPainel = useCallback(async () => {
    try {
      const p = await api.get<Painel>('/api/campanhas-fly');
      setPainel(p);
      if (!textoTocado.current) setTexto(p.texto_padrao ?? '');
    } catch { /* o painel e' informativo; falhar nele nao pode travar a montagem */ }
  }, []);

  useEffect(() => {
    void (async () => {
      let lista: FlySalvo[] = [];
      try { lista = await atendimentoApi.listarFlysSalvos(); } catch { /* segue sem flys */ }
      setFlys(lista);
      // O F5 veio no meio de uma EDICAO: reabre a mesma campanha e repoe os produtos que ele
      // tinha escolhido. Depois dos flys, porque a reabertura decide por eles qual porta usar.
      if (rascunhoLido?.editandoId) await abrirEdicao({ id: rascunhoLido.editandoId }, rascunhoLido, lista);
    })();
    void carregarPainel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [carregarPainel]);

  // Uma chamada so' pra todos os flys guardados: quais produtos deles nao servem pra campanha.
  useEffect(() => {
    const ids = [...new Set(flys.flatMap((f) => f.produtos.map((p) => p.id)))].slice(0, 500);
    if (ids.length === 0) { setSemComercialFlys(new Set()); return; }
    let vivo = true;
    api.post<{ faltando: Array<{ id: number }> }>('/api/campanhas-fly/conferir-somente-texto', { produto_ids: ids })
      .then((r) => { if (vivo) setSemComercialFlys(new Set(r.faltando.map((p) => p.id))); })
      .catch(() => { if (vivo) setSemComercialFlys(new Set()); });
    return () => { vivo = false; };
  }, [flys]);

  // ⚠️ UMA DE CADA VEZ, nunca em paralelo. Quem desenha a arte e' o mesmo Puppeteer que o worker
  // usa pra MANDAR: disparar dez de uma vez tiraria a vez dele no meio de uma campanha correndo.
  // Cada arte custa 0,7 a 2,3 s na primeira vez e sai do cache depois ([DA-682]).
  useEffect(() => {
    if (!flys.length) return;
    let vivo = true;
    void (async () => {
      for (const f of flys) {
        if (!vivo) return;
        if (pedidas.current.has(f.id)) continue;
        pedidas.current.add(f.id);
        setDesenhando(f.id);
        try {
          const r = await desenharEmFila(f.produtos.map((p) => p.id));
          if (vivo) setArtes((a) => ({ ...a, [f.id]: r }));
        } catch {
          if (vivo) setArtes((a) => ({ ...a, [f.id]: 'erro' }));
        } finally {
          if (vivo) setDesenhando(null);
        }
      }
    })();
    return () => { vivo = false; };
  }, [flys, desenharEmFila]);

  // A previa das campanhas SEM arte enviada. So' as que conseguem ter arte: texto puro nao tem, e
  // quantidade fora de 1-3/12 a funcao recusaria — o quadro diz o motivo em vez de pedir.
  useEffect(() => {
    const semArte = (painel?.campanhas ?? []).filter((c) => !c.fly_url && !c.somente_texto
      && (c.produto_ids?.length ?? 0) > 0 && !motivoRetomar(c));
    for (const c of semArte) {
      const chave = c.produto_ids!.join('-');
      if (previasPedidas.current.has(chave)) continue;
      previasPedidas.current.add(chave);
      desenharEmFila(c.produto_ids!)
        .then((r) => setPreviasLista((p) => ({ ...p, [chave]: r.imagem })))
        .catch(() => setPreviasLista((p) => ({ ...p, [chave]: 'erro' })));
    }
  }, [painel, desenharEmFila]);

  // A previa refaz a cada troca de etiqueta ou da caixa de frios — sao os dois eixos que mudam
  // QUEM recebe. Trocar o fly ou o texto muda o QUE sai, e nao mexe na conta.
  //
  // ⚠️ A selecao fica so' com quem AINDA esta na lista nova. Com varias etiquetas, acrescentar
  // uma segunda nao pode jogar fora o que ele ja desmarcou na primeira; mas marca de quem saiu
  // da populacao nao pode sobrar, senao os contadores ("N voce desmarcou") contam fantasma.
  const chaveEtiquetas = etiquetaIds.join(',');
  const editandoId = editando?.id ?? null;
  useEffect(() => {
    if (!chaveEtiquetas) { setPrevia(null); return; }
    let vivo = true;
    setCarregandoPrevia(true);
    void (async () => {
      try {
        const r = await api.post<Previa>('/api/campanhas-fly/previa', {
          etiqueta_ids: chaveEtiquetas.split(',').map(Number), incluir_frios: incluirFrios,
          // Editando, o servidor tira das listas quem ja recebeu desta campanha.
          ...(editandoId ? { campanha_id: editandoId } : {}),
        });
        if (vivo) {
          setPrevia(r);
          const naFila = inicioEdicao.current;
          if (naFila) {
            inicioEdicao.current = null;
            const abriramDesmarcados = r.recebem.filter((c) => !naFila.has(c.chave));
            setDesmarcados(new Set(abriramDesmarcados.map((c) => c.chave)));
            const reg = registroEdicao.current;
            registroEdicao.current = null;
            setMotivoAbertura(new Map(abriramDesmarcados.map((c) => [
              c.chave, motivoDoDesmarcado(reg, c.pessoa ?? c.chave, r.excluidos),
            ])));
            setResgatados(new Set(r.fora.filter((c) => c.resgatavel && naFila.has(c.chave)).map((c) => c.chave)));
          } else {
            const recebemAgora = new Set(r.recebem.map((c) => c.chave));
            const foraAgora = new Set(r.fora.map((c) => c.chave));
            setDesmarcados((s) => new Set([...s].filter((k) => recebemAgora.has(k))));
            setResgatados((s) => new Set([...s].filter((k) => foraAgora.has(k))));
          }
        }
      } catch {
        if (vivo) setPrevia(null);
      } finally {
        if (vivo) setCarregandoPrevia(false);
      }
    })();
    return () => { vivo = false; };
  }, [chaveEtiquetas, incluirFrios, editandoId, recargaPrevia]);

  /**
   * Lixeira dos "numero nao entrega" — pedido dele em 24/09/2026. A previa, a confirmacao e o
   * DELETE moram em `excluirContatoDeVez`, a mesma peca da lixeira da aba Contatos.
   */
  async function excluirContatoQuebrado(contatoId: number) {
    if (await excluirContatoDeVez(contatoId, dialog, toast)) setRecargaPrevia((n) => n + 1);
  }

  const recebem = previa?.recebem ?? [];
  const fora = previa?.fora ?? [];
  // O exemplo REAL da variavel `@NOME` — o primeiro nome de quem vai receber, assim que a
  // previa da etiqueta souber quem e' ([[fly-variaveis]]: a previa mostra um exemplo real).
  const nomeExemplo = recebem[0]?.nome ?? null;
  // E o da `@FREQUENCIA`, da MESMA pessoa ([DA-811]): desde que a regua virou por etiqueta, a
  // frase nao e' igual pra todo mundo. Sem previa ainda, o padrao de 7 dias.
  const frequenciaExemplo = recebem[0]?.frequencia_dias ?? 7;

  const chavesAEnviar = useMemo(
    () => recebem.filter((r) => !desmarcados.has(r.chave)).map((r) => r.chave),
    [recebem, desmarcados],
  );
  const vaoReceber = chavesAEnviar.length + resgatados.size;

  // ⚠️ Recalculado AQUI e nao lido do `dias_estimados` da previa: o servidor conta sobre todos os
  // elegiveis, e ele acabou de tirar gente da lista. Numero que nao acompanha a selecao promete
  // um prazo que a campanha nao vai cumprir.
  const teto = previa?.teto_diario ?? painel?.teto_diario ?? 0;
  const diasEstimados = teto > 0 && vaoReceber > 0 ? Math.ceil(vaoReceber / teto) : null;

  // ⚠️ `@FREQUENCIA` e `@NOME` sao POR DESTINATARIO ([DA-811]) — aqui as duas se trocam por um
  // EXEMPLO REAL, o primeiro de quem recebe, com as mesmas funcoes que o worker usa no envio
  // ([[fly-variaveis]] em `@fiodecobre/shared`, DA-591). A frequencia primeiro: e' a chave longa.
  const resolverExemplo = useCallback(
    (t: string) => resolverNomeContato(resolverFrequencia(t, frequenciaExemplo), nomeExemplo),
    [frequenciaExemplo, nomeExemplo],
  );
  const textoResolvido = useMemo(() => resolverExemplo(texto), [texto, resolverExemplo]);

  const podeSalvarPadrao = !!painel && !!texto.trim() && texto.trim() !== (painel.texto_padrao ?? '').trim();

  const filtroNorm = filtro.trim().toLowerCase();
  // ⛔ Os digitos so' entram na comparacao quando EXISTEM. Ate 21/09/2026 a perna do numero era
  // `chave.includes(filtroNorm.replace(/\D/g, ''))` — e num termo so' de letras aquilo vira
  // `chave.includes('')`, que e' SEMPRE verdadeiro: o OR passava a lista inteira e a busca por
  // NOME nunca filtrou nada. Medido em prod nesse dia: `9968` devolvia 2 linhas e `Amilton`
  // devolvia as 75 — e o placeholder promete "procurar por nome ou numero" ([DA-639]).
  const filtroDigitos = filtroNorm.replace(/\D/g, '');
  const combina = useCallback((nomeContato: string | null, chave: string) => {
    if (!filtroNorm) return true;
    if ((nomeContato ?? '').toLowerCase().includes(filtroNorm)) return true;
    return filtroDigitos.length > 0 && chave.includes(filtroDigitos);
  }, [filtroNorm, filtroDigitos]);

  const recebemFiltrados = recebem.filter((r) => combina(r.nome, r.chave));
  // A coluna de etiqueta so' aparece com MAIS de uma etiqueta: com uma so', toda linha levaria o
  // mesmo selo e ele nao distinguiria nada. Na ordem em que ele escolheu as etiquetas.
  const etiquetasDaLinha = (ids?: number[]): Etiqueta[] | undefined => {
    // Lista VAZIA (e nao undefined) quando a pessoa nao traz etiqueta: a linha precisa manter a
    // coluna, senao o nome dela estica e desalinha das vizinhas.
    if (etiquetaIds.length < 2) return undefined;
    if (!ids?.length) return [];
    return etiquetaIds
      .filter((id) => ids.includes(id))
      .map((id) => etiquetas.find((e) => e.id === id))
      .filter((e): e is Etiqueta => !!e);
  };

  // A caixa do cabecalho — pedido dele em 21/09/2026, alinhada na coluna das caixas das linhas.
  //
  // ⚠️ Ela conta os VISIVEIS, a mesma populacao que os dois botoes ao lado ja mexem: com filtro
  // ligado, marcar/desmarcar alcanca o que esta na tela e nao a etiqueta inteira. Contar a lista
  // toda faria a caixa dizer uma coisa e o clique fazer outra.
  //
  // ⚠️ O terceiro estado (`indeterminate`) nao e' enfeite: sem ele, "49 de 50" desenharia uma
  // caixa VAZIA, e caixa vazia sobre uma lista quase toda marcada e' a tela afirmando o oposto do
  // que ela mostra logo abaixo.
  const visiveisMarcados = recebemFiltrados.filter((r) => !desmarcados.has(r.chave)).length;
  const todosVisiveisMarcados = recebemFiltrados.length > 0 && visiveisMarcados === recebemFiltrados.length;
  const algunsVisiveisMarcados = visiveisMarcados > 0 && !todosVisiveisMarcados;

  // Os de fora vao AGRUPADOS pelo motivo: 45 linhas repetindo a mesma frase escondem justamente
  // o que separa um grupo do outro — qual deles ele pode desfazer.
  const gruposFora = useMemo(() => {
    const mapa = new Map<string, { texto: string; resgatavel: boolean; linhas: ForaDaLista[] }>();
    for (const f of fora) {
      if (!combina(f.nome, f.chave)) continue;
      // Motivo + TEXTO: o `ja_recebeu_fly` diz o intervalo de cada pessoa ([DA-811]), e agrupar
      // so' pelo motivo poria o eletricista de 1 dia debaixo de "nos ultimos 7 dias".
      const k = (f.motivo ?? 'sem_motivo') + '|' + (f.texto ?? '');
      const g = mapa.get(k) ?? { texto: f.texto ?? 'sem motivo', resgatavel: f.resgatavel, linhas: [] };
      g.linhas.push(f);
      mapa.set(k, g);
    }
    // Resgatavel em cima: e' onde ele tem o que decidir.
    return [...mapa.entries()].sort((a, b) =>
      Number(b[1].resgatavel) - Number(a[1].resgatavel) || b[1].linhas.length - a[1].linhas.length);
  }, [fora, combina]);

  function alternarRecebe(chave: string) {
    setDesmarcados((s) => {
      const novo = new Set(s);
      if (novo.has(chave)) novo.delete(chave); else novo.add(chave);
      return novo;
    });
  }

  function alternarResgate(chave: string) {
    setResgatados((s) => {
      const novo = new Set(s);
      if (novo.has(chave)) novo.delete(chave); else novo.add(chave);
      return novo;
    });
  }

  // ⚠️ O botao do cabecalho age sobre o que o FILTRO esta mostrando, nao sobre a lista inteira:
  // "desmarcar todos" varrendo gente que ele nao esta vendo e' decisao minha com a assinatura
  // dele em cima.
  function marcarTodosVisiveis(marcar: boolean) {
    setDesmarcados((s) => {
      const novo = new Set(s);
      for (const r of recebemFiltrados) {
        if (marcar) novo.delete(r.chave); else novo.add(r.chave);
      }
      return novo;
    });
  }

  function resgatarGrupo(linhas: ForaDaLista[], marcar: boolean) {
    setResgatados((s) => {
      const novo = new Set(s);
      for (const l of linhas) {
        if (marcar) novo.add(l.chave); else novo.delete(l.chave);
      }
      return novo;
    });
  }

  // ── SOMENTE TEXTO: o picker AD-HOC ────────────────────────────────────────────────────────

  /** Decisao 6: aponta quais produtos NAO servem pro modo texto — nunca remove sozinha. */
  async function conferirDescricaoComercial(ids: number[]) {
    if (ids.length === 0) { setAvisoDescricao([]); return; }
    try {
      const r = await api.post<{ faltando: Array<{ id: number; descricao: string }> }>(
        '/api/campanhas-fly/conferir-somente-texto', { produto_ids: ids },
      );
      setAvisoDescricao(r.faltando);
    } catch { setAvisoDescricao([]); }
  }

  /**
   * Liga/desliga o Somente Texto. Decisao 6 (ligar): herda os produtos do fly guardado como
   * ponto de partida, se o picker ad-hoc ainda nao foi tocado. Decisao 4/5 (desligar): se a
   * lista ad-hoc tem produtos demais pro fly com arte, TRUNCA pelo maior formato que ela
   * alcanca e AVISA — truncar calado e' proibido.
   */
  function alternarSomenteTexto(ligar: boolean) {
    setAvisoTruncamento(null);
    if (ligar) {
      if (!adHocTocado.current && flyEscolhido) {
        const base: ProdutoEscolha[] = flyEscolhido.produtos.map((p) => ({
          id: p.id, codigo_interno: p.codigo_interno, descricao: p.descricao,
          preco_pix: p.preco_pix, foto_url: p.foto_url, estoque: p.estoque,
          tem_descricao_comercial: true, // a conferencia abaixo corrige se algum nao tiver
        }));
        setProdutosAdHoc(base);
        void conferirDescricaoComercial(base.map((p) => p.id));
      }
      setSomenteTexto(true);
    } else {
      if (adHocTocado.current && produtosAdHoc.length > 0) {
        const { entram, fora } = truncarParaFormatoFly(produtosAdHoc);
        setProdutosAdHoc(entram);
        if (fora.length > 0) setAvisoTruncamento({ entram: entram.length, fora: fora.length });
        // Nao e' mais o fly guardado — e' uma combinacao nova, ad-hoc.
        setFlyId(null);
        // ⚠️ O aviso NAO zera mais ao desligar ([DA-742]): a arte da campanha tambem exige a
        // Descricao Comercial, entao o produto sem ela continua barrado — so' que agora na arte.
        void conferirDescricaoComercial(entram.map((p) => p.id));
      } else {
        setAvisoDescricao([]);
      }
      setSomenteTexto(false);
    }
  }

  /**
   * Por que este produto nao pode entrar — `null` quando pode. A tela RECUSA no clique e nunca
   * esconde o produto da busca (decisao 3 dele): escondido, ele procuraria um produto que
   * existe e nao acharia.
   *
   * ⚠️ Os DOIS modos exigem a Descricao Comercial desde a [DA-742] (decisao dele, 23/09/2026: o
   * nome que vai na arte e' o mesmo do texto puro, nunca o de estoque). A FOTO continua sendo so'
   * da arte.
   */
  function motivoDoBloqueio(p: ProdutoEscolha): string | null {
    const semFoto = !somenteTexto && !p.foto_url;
    const semComercial = !p.tem_descricao_comercial;
    if (semFoto && semComercial) return 'Este produto não tem foto nem Descrição Comercial — preencha no cadastro do produto';
    if (semComercial) return 'Este produto não tem Descrição Comercial — preencha na aba Catálogo do produto';
    if (semFoto) return 'Este produto não tem foto — o fly com imagem precisa de uma';
    return null;
  }

  /**
   * O mesmo impedimento, curto, pra ficar ESCRITO na linha (pedido dele em 23/09/2026).
   *
   * ⚠️ Ate hoje o motivo so' existia no `title` e no toast do clique — e o unico sinal na tela
   * era a linha mais apagada com um ⚠️ de 13px, que no print dele nao se enxerga. Aviso que so'
   * aparece ao passar o mouse nao existe pra quem esta decidindo o que anunciar.
   */
  function rotulosDoBloqueio(p: ProdutoEscolha): string[] {
    const r: string[] = [];
    if (!somenteTexto && !p.foto_url) r.push('Sem foto');
    if (!p.tem_descricao_comercial) r.push('Sem Descrição Comercial');
    return r;
  }

  /**
   * Foto a esquerda e estoque a direita, entre parenteses, nas etiquetas dos produtos ESCOLHIDOS
   * (pedido dele em 25/09/2026: *"facilitar a identificacao do produto pela foto e so de olhar
   * da para saber se a quantidade do item divulgado esta com um bom estoque"*).
   * ⚠️ Estoque sem o campo (rascunho antigo) nao desenha nada — nunca um `(0)` inventado.
   */
  function fotoDoChip(p: ProdutoEscolha) {
    return p.foto_url
      ? <FotoProduto url={p.foto_url} tam={28} style={{ flexShrink: 0 }} />
      : <Package size={28} strokeWidth={1} style={{ flexShrink: 0 }} />;
  }
  function estoqueDoChip(p: ProdutoEscolha) {
    if (p.estoque === undefined || p.estoque === null) return null;
    return <strong className="tabular-nums" style={{ flex: '0 0 auto', whiteSpace: 'nowrap' }}>({fmtEstoque(p.estoque)})</strong>;
  }

  /** Clicar num produto da busca — adiciona ou tira. */
  function alternarProdutoAdHoc(p: ProdutoEscolha) {
    // A recusa vem ANTES de largar o fly: produto recusado nao pode desfazer uma escolha valida.
    // (Decidido fora do updater — la dentro ele roda no render seguinte, tarde demais pra isto.)
    const ja = produtosAdHoc.some((x) => x.id === p.id);
    if (!ja) {
      const motivo = motivoDoBloqueio(p);
      if (motivo) { toast.erro(motivo); return; }
    }
    adHocTocado.current = true;
    // [DA-743]: marcar um produto LARGA o fly guardado — vale o ultimo gesto.
    if (!somenteTexto && flyId !== null) setFlyId(null);
    setProdutosAdHoc((atuais) => (atuais.some((x) => x.id === p.id)
      ? atuais.filter((x) => x.id !== p.id)
      : [...atuais, p]));
  }

  /** Escolher um fly guardado LARGA a combinacao da busca; clicar no escolhido o larga ([DA-743]). */
  function escolherFly(id: number) {
    if (flyId === id) { setFlyId(null); return; }
    setFlyId(id);
    descartarAdHoc();
  }

  /**
   * Guardar a combinacao montada na busca como fly guardado — pedido dele, 23/09/2026: *"Criei
   * este fly, mas nao vi onde esta o botao de salvar"* ([DA-744]). Ate aqui o botao so' existia
   * no chat (`ModalEnviarMaterial`), e a campanha virou o lugar natural de montar um fly desde a
   * [DA-743].
   *
   * ⛔ UM clique, nome pronto — a licao da [DA-707]: botao "Salvar" que so' abre um campo de nome
   * perde o gesto entre os dois cliques. O nome e' o da CAMPANHA quando ele ja digitou (e' como
   * ele chama aquela oferta); senao, o mesmo sugerido do chat. Renomear segue no lapis do chat.
   * ⚠️ Corta em 80: e' o teto da rota, e um catalogo de 12 com o nome sugerido passa disso.
   */
  const [salvandoFly, setSalvandoFly] = useState(false);
  async function salvarFlyAtual() {
    if (produtosAdHoc.length === 0 || salvandoFly) return;
    const sugerido = produtosAdHoc.map((p) => p.descricao.split(' ').slice(0, 2).join(' ')).join(' + ');
    const nomeFly = (nome.trim() || sugerido).slice(0, 80).trim();
    setSalvandoFly(true);
    try {
      const r = await atendimentoApi.salvarFly({ nome: nomeFly, produto_ids: produtosAdHoc.map((p) => p.id) });
      setFlys(await atendimentoApi.listarFlysSalvos());
      // Ja entra ESCOLHIDO: a combinacao na tela e' exatamente ele, e assim a campanha nasce
      // amarrada ao fly guardado em vez de a uma copia solta dos mesmos produtos.
      setFlyId(r.id);
      descartarAdHoc();
      toast.sucesso(`Guardado em "Ou use um fly guardado" como "${nomeFly}" — renomeie pelo lápis de Meus Flys, no chat.`);
    } catch (e) {
      toast.erro((e as Error).message || 'não consegui guardar este fly');
    } finally {
      setSalvandoFly(false);
    }
  }

  /** Larga a combinacao montada na busca. */
  function descartarAdHoc() {
    setProdutosAdHoc([]);
    setAvisoDescricao([]);
    setAvisoTruncamento(null);
    adHocTocado.current = false;
  }

  // Sem fly guardado escolhido, o que vale e' a combinacao da busca — que agora esta SEMPRE na
  // tela, junto com a lista de flys ([DA-743]; antes era uma das duas, trocadas por botao).
  const usandoAdHocEmImagem = !somenteTexto && flyId === null;

  // Grava a escolha a cada mudanca, pra o F5 achar. Disparar zera os tres, e isso grava vazio.
  useEffect(() => {
    try {
      const r: RascunhoProdutos = {
        somenteTexto, produtos: produtosAdHoc, flyId, adHocTocado: adHocTocado.current, editandoId: editando?.id ?? null,
      };
      sessionStorage.setItem(CHAVE_RASCUNHO_PRODUTOS, JSON.stringify(r));
    } catch { /* sem storage, so' nao lembra */ }
  }, [somenteTexto, produtosAdHoc, flyId, editando]);

  // Restaurou produtos? O aviso de "sem Descricao Comercial" nao viaja no rascunho — e o
  // cadastro pode ter mudado enquanto a tela estava fechada. Reconfere uma vez.
  useEffect(() => {
    if (rascunhoInicial && rascunhoInicial.produtos.length > 0) {
      void conferirDescricaoComercial(rascunhoInicial.produtos.map((p) => p.id));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Busca do picker ad-hoc. Mesma guarda de corrida da busca de fly (a resposta mais NOVA e'
  // quem manda). ⚠️ A rota vai com `modo=texto` nos dois modos de proposito: e' a unica que
  // devolve `tem_descricao_comercial` e nao esconde produto sem foto — quem recusa e' o clique,
  // com o motivo do modo (sem descricao nos dois modos desde a [DA-742]; sem foto so' na arte).
  const reqBuscaAdHoc = useRef(0);
  // A busca esta na tela o tempo todo nos dois modos desde a [DA-743], entao roda sempre.
  useEffect(() => {
    setCarregandoBuscaAdHoc(true);
    const req = ++reqBuscaAdHoc.current;
    const timer = setTimeout(() => {
      atendimentoApi.buscarProdutosParaEnvioTexto(buscaAdHoc.trim())
        .then((r) => { if (req === reqBuscaAdHoc.current) setProdutosBuscaAdHoc(r); })
        .catch(() => { if (req === reqBuscaAdHoc.current) setProdutosBuscaAdHoc([]); })
        .finally(() => { if (req === reqBuscaAdHoc.current) setCarregandoBuscaAdHoc(false); });
    }, buscaAdHoc.trim() ? 250 : 0);
    return () => clearTimeout(timer);
  }, [buscaAdHoc]);

  // A previa da mensagem SEM arte — a MESMA funcao do envio (DA-591), respiro de 400ms pra nao
  // gerar uma previa por clique numa selecao grande.
  const chaveAdHoc = produtosAdHoc.map((p) => p.id).join('-');
  useEffect(() => {
    if (!somenteTexto || produtosAdHoc.length === 0) {
      setMensagemTextoPrevia(null); setErroMensagemTexto(null); setCarregandoMensagemTexto(false);
      return;
    }
    let vivo = true;
    setCarregandoMensagemTexto(true);
    setErroMensagemTexto(null);
    const timer = setTimeout(() => {
      api.post<{ mensagem: string }>('/api/campanhas-fly/mensagem-texto', {
        produto_ids: produtosAdHoc.map((p) => p.id), texto: texto.trim() || null,
      })
        .then((r) => { if (vivo) setMensagemTextoPrevia(r.mensagem); })
        .catch((e: unknown) => {
          if (!vivo) return;
          setMensagemTextoPrevia(null);
          setErroMensagemTexto((e as { message?: string })?.message || 'Não consegui montar a prévia');
        })
        .finally(() => { if (vivo) setCarregandoMensagemTexto(false); });
    }, 400);
    return () => { vivo = false; clearTimeout(timer); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [somenteTexto, chaveAdHoc, texto]);

  // A arte de uma combinacao AD-HOC no modo IMAGEM (escolhida aqui, ou sobra de um
  // desligar-com-truncamento). `/arte` aceita `produto_ids` direto.
  //
  // ⚠️ Quantidade invalida nao pede arte: o servidor recusaria e a tela diria "nao consegui
  // desenhar", que manda cacar um defeito onde so' falta um produto. O motivo certo ja esta
  // escrito acima da busca.
  useEffect(() => {
    if (somenteTexto || flyId !== null || produtosAdHoc.length === 0
        || motivoQuantidadeFly(produtosAdHoc.length)) { setArteAdHoc(null); return; }
    let vivo = true;
    void (async () => {
      try {
        const r = await api.post<Arte>('/api/campanhas-fly/arte', { produto_ids: produtosAdHoc.map((p) => p.id) });
        if (vivo) setArteAdHoc(r);
      } catch {
        if (vivo) setArteAdHoc('erro');
      }
    })();
    return () => { vivo = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [somenteTexto, flyId, chaveAdHoc]);

  const motivoQtdAdHoc = usandoAdHocEmImagem ? motivoQuantidadeFly(produtosAdHoc.length) : null;

  // ⚠️ O aviso vale so' pro que AINDA esta na lista: a instrucao dele e' "preencha, ou tire da
  // lista" — e ate a [DA-742] tirar nao apagava o aviso, entao o botao seguia travado depois de
  // ele fazer exatamente o que a tela mandou.
  const avisoAtivo = avisoDescricao.filter((f) => produtosAdHoc.some((p) => p.id === f.id));
  // O mesmo aviso pro fly GUARDADO escolhido ([DA-742]): ele nao passa pelo picker, entao a
  // recusa do clique nao o alcanca.
  const semComercialFlyEscolhido = !somenteTexto && !usandoAdHocEmImagem && flyEscolhido
    ? flyEscolhido.produtos.filter((p) => semComercialFlys.has(p.id))
    : [];
  const produtosSemComercial = somenteTexto || usandoAdHocEmImagem ? avisoAtivo : semComercialFlyEscolhido;

  // ⚠️ O botao DIZ o que falta, nunca fica apagado e mudo — beco sem saida nao e' interface
  // limpa. Cada linha aqui e' uma frase que aparece embaixo do botao.
  //
  // ⚠️ Duas listas desde 23/09/2026 (decisao dele): SALVAR (a campanha fica pausada) aceita
  // qualquer quantidade ate 12 — *"independente de quantos produtos tenha, respeitando o limite
  // maximo de 12"* —, e PUBLICAR exige o 1-3/12 inteiro, porque e' ele que poe a arte pra sair.
  const faltando: string[] = [];
  let faltaQtdPublicar: string | null = null;
  if (somenteTexto) {
    if (produtosAdHoc.length === 0) faltando.push('escolha ao menos um produto');
  } else if (usandoAdHocEmImagem) {
    // Sem fly e sem produto, o motivo da quantidade ja diz o que falta — e a lista de flys
    // guardados esta logo abaixo da busca, sem botao no caminho ([DA-743]).
    if (produtosAdHoc.length === 0 || produtosAdHoc.length > FLY_CATALOGO_PRODUTOS) {
      if (motivoQtdAdHoc) faltando.push(motivoQtdAdHoc);
    } else {
      faltaQtdPublicar = motivoQtdAdHoc;
    }
  }
  if (produtosSemComercial.length > 0) faltando.push('resolva os produtos sem Descrição Comercial');
  if (!temEtiqueta) faltando.push('escolha a etiqueta');
  if (!nome.trim()) faltando.push('dê um nome à campanha');
  if (temEtiqueta && !previa) faltando.push('aguardando a prévia');
  if (previa && previa.elegiveis === 0 && resgatados.size === 0) {
    faltando.push(etiquetaIds.length > 1 ? 'ninguém destas etiquetas pode receber agora' : 'ninguém desta etiqueta pode receber agora');
  }
  if (previa && vaoReceber === 0 && previa.elegiveis > 0) faltando.push('você desmarcou todo mundo');
  if (!iniciaEm) faltando.push('escolha a data inicial do disparo');

  // Editando, Salvar so' acende com ALTERACAO (pedido dele, 23/09/2026). A foto do formulario e'
  // tirada quando a edicao termina de carregar — produtos, etiquetas E a selecao que a previa
  // repoe —; dali em diante qualquer diferenca conta.
  const assinatura = JSON.stringify([
    nome, iniciaEm, etiquetaIds, incluirFrios, texto, somenteTexto,
    somenteTexto || usandoAdHocEmImagem ? produtosAdHoc.map((p) => p.id) : flyEscolhido?.produtos.map((p) => p.id) ?? [],
    somenteTexto || usandoAdHocEmImagem ? null : flyEscolhido?.id ?? null,
    [...desmarcados].sort(), [...resgatados].sort(),
  ]);
  useEffect(() => {
    if (editando && assinaturaInicial === null && previa && !carregandoPrevia && inicioEdicao.current === null) {
      setAssinaturaInicial(assinatura);
    }
  }, [editando, previa, carregandoPrevia, assinatura, assinaturaInicial]);
  const alterado = !editando || (assinaturaInicial !== null
    && (restauradoDiferente.current || assinatura !== assinaturaInicial));

  const podeSalvar = faltando.length === 0 && alterado && !carregandoPrevia && !enviando;
  const podePublicar = faltando.length === 0 && !faltaQtdPublicar && !carregandoPrevia && !enviando;
  // O que aparece no rodape: o que trava os DOIS, e depois o que trava so' o publicar.
  const faltandoRodape = faltaQtdPublicar ? [...faltando, 'para publicar: ' + faltaQtdPublicar] : faltando;

  async function salvarPadrao() {
    try {
      const r = await api.put<{ texto_padrao: string }>('/api/campanhas-fly/texto-padrao', {
        texto: texto.trim(),
      });
      setPainel((p) => (p ? { ...p, texto_padrao: r.texto_padrao } : p));
      toast.sucesso('Este texto passa a vir preenchido em toda campanha nova.');
    } catch (e) {
      toast.erro((e as Error).message || 'não consegui salvar o texto padrão');
    }
  }

  // Os produtos que VAO na campanha — de qual porta, depende do modo (decisao 2/4/6).
  const produtoIdsFinal = somenteTexto || usandoAdHocEmImagem
    ? produtosAdHoc.map((p) => p.id)
    : flyEscolhido?.produtos.map((p) => p.id) ?? [];
  const flySalvoIdFinal = somenteTexto || usandoAdHocEmImagem ? null : flyEscolhido?.id ?? null;

  /** Volta o formulario ao estado de campanha nova — depois de criar, de salvar, ou ao desistir da edicao. */
  function limparFormulario() {
    setEditando(null);
    inicioEdicao.current = null;
    registroEdicao.current = null;
    setMotivoAbertura(new Map());
    setAssinaturaInicial(null);
    restauradoDiferente.current = false;
    setNome(''); setIniciaEm(hojeISO()); setFlyId(null); setEtiquetaIds([]); setIncluirFrios(false);
    setPrevia(null); setDesmarcados(new Set()); setResgatados(new Set()); setFiltro('');
    textoTocado.current = false;
    setTexto(painel?.texto_padrao ?? '');
    setSomenteTexto(false); descartarAdHoc(); setBuscaAdHoc('');
  }

  /**
   * Reabre uma campanha no formulario (pedido dele, 23/09/2026). A mudanca vale so' pra quem
   * ainda nao recebeu — decisao dele, mesmo sabendo que a lista pode sair com dois flys.
   *
   * ⚠️ Os produtos voltam pela porta do fly guardado quando ele ainda existe (e o modo e' com
   * arte); senao, como combinacao solta — os dois caminhos que a tela ja tem pra criar.
   */
  //
  // `rascunho` so' vem da recarga no meio da edicao: os produtos/modo que ele tinha na tela
  // substituem os gravados, e se diferirem o Salvar ja nasce aceso. `listaFlys` porque na
  // montagem o estado `flys` ainda nao chegou a este fechamento.
  //
  // `republicar` (pedido dele, 06/10/2026: *"alterar algum detalhe da campanha e poder republicar;
  // na republicacao so' recebe quem esta fora da janela dos 7 dias"*): a campanha que ja rodou
  // vira o PONTO DE PARTIDA de uma campanha NOVA — mesmo fly, texto e etiquetas, sem `editando`.
  // A janela de 7 dias nao precisa de nada aqui: ela ja vale pra toda campanha (`ja_recebeu_fly`,
  // na previa e de novo no envio). Campanha nova = numero novo e post novo no Instagram.
  async function abrirEdicao(c: { id: number }, rascunho?: RascunhoProdutos, listaFlys: FlySalvo[] = flys, republicar = false) {
    try {
      const e = await api.get<CampanhaParaEditar>('/api/campanhas-fly/' + c.id);
      if (!republicar && !e.editavel) {
        toast.erro('Esta campanha está ' + e.status + ' — só campanha pausada se edita.');
        if (rascunho) limparFormulario();
        return;
      }
      limparFormulario();
      if (!republicar) {
        inicioEdicao.current = new Map(e.fila.map((f) => [f.chave, f.resgatado]));
        registroEdicao.current = { fora: e.fora_na_montagem, montadaEm: e.fila_montada_em };
        setEditando({ id: e.id, nome: e.nome });
      }
      setNome(e.nome.toUpperCase());
      setIniciaEm(republicar ? hojeISO() : e.inicia_em);
      setEtiquetaIds(e.etiqueta_ids);
      setIncluirFrios(e.incluir_frios);
      textoTocado.current = true;
      setTexto(e.texto ?? '');
      const flyGuardado = !e.somente_texto && e.fly_salvo_id !== null
        ? listaFlys.find((f) => f.id === e.fly_salvo_id) : undefined;
      // O que estava gravado, na forma do rascunho — pra comparar com o que o F5 trouxe.
      const gravado = {
        somenteTexto: e.somente_texto,
        flyId: flyGuardado?.id ?? null,
        ids: flyGuardado ? [] : e.produtos.map((p) => p.id),
      };
      const usar = rascunho && (rascunho.flyId === null || listaFlys.some((f) => f.id === rascunho.flyId))
        ? { somenteTexto: rascunho.somenteTexto, flyId: rascunho.flyId, produtos: rascunho.produtos }
        : { somenteTexto: gravado.somenteTexto, flyId: gravado.flyId, produtos: flyGuardado ? [] : e.produtos };
      restauradoDiferente.current = JSON.stringify([usar.somenteTexto, usar.flyId, usar.flyId === null ? usar.produtos.map((p) => p.id) : []])
        !== JSON.stringify([gravado.somenteTexto, gravado.flyId, gravado.ids]);
      setSomenteTexto(usar.somenteTexto);
      if (usar.flyId !== null) {
        setFlyId(usar.flyId);
      } else {
        adHocTocado.current = true;
        // O produto vem sempre do que a rota acabou de ler — descricao, preco, foto e estoque: o do
        // rascunho e' de quando ele foi guardado. Repor so' o estoque deixava a Descricao Comercial
        // alterada no cadastro presa no nome antigo, mesmo com F5 (relato dele, 10/10/2026).
        // A rota ja devolve o produto no formato da busca. Produto que so' o rascunho tem
        // (acrescentado na edicao, ainda nao gravado) segue como estava.
        const agora = new Map(e.produtos.map((p) => [p.id, p]));
        setProdutosAdHoc(usar.produtos.map((p) => ({ ...p, ...agora.get(p.id) })));
        void conferirDescricaoComercial(usar.produtos.map((p) => p.id));
      }
      setVista('nova');
      if (republicar) {
        toast.sucesso('Copiada como campanha NOVA — ajuste o que quiser e publique. Quem recebeu fly dentro da frequência das etiquetas dele fica de fora.');
      }
    } catch (err) {
      toast.erro((err as Error).message || 'não consegui abrir a campanha');
      if (rascunho) limparFormulario();
    }
  }

  // `iniciar = false` e' o so' SALVAR: a campanha fica PAUSADA e so' anda pelo Retomar da aba Em
  // andamento. `true` e' o "Salvar e publicar". Decisao dele, 23/09/2026: *"A campanha ao ser
  // criada, deve tambem ficar pausada. A menos que clique em salvar e publicar"* — vale na
  // criacao e na edicao (que so' abre campanha pausada).
  async function disparar(iniciar: boolean) {
    if (!(iniciar ? podePublicar : podeSalvar) || !previa || produtoIdsFinal.length === 0 || !temEtiqueta) return;
    const nomesEtq = etiquetaIds.map((id) => etiquetas.find((e) => e.id === id)?.nome ?? '').filter(Boolean);
    const etq = nomesEtq.length > 1
      ? 'das etiquetas ' + nomesEtq.join(', ')
      : etiquetaIds[0] === SEM_ETIQUETA_ID ? 'sem etiqueta' : 'da etiqueta ' + (nomesEtq[0] ?? '');
    // A confirmacao repete o NUMERO e o PRAZO, porque sao os dois que ele nao pode descobrir
    // depois: quantas pessoas vao receber, e por quantos dias a loja vai estar disparando. Desde
    // a [DA-714] o numero e' o da SELECAO dele, e os resgates aparecem separados — resgatar e'
    // furar uma guarda de proposito, e isso se confirma dizendo em voz alta.
    const jaNaCampanha = previa.ja_na_campanha ?? 0;
    // Data futura se DIZ na confirmacao: publicar e nada sair hoje le como defeito.
    const inicioFuturo = iniciaEm > hojeISO();
    const ok = await dialog.confirmar(
      (!iniciar ? 'A campanha fica salva e PAUSADA — nada é enviado agora. Quando quiser começar, clique em Retomar na aba Em andamento.\n\n' : '')
      + (inicioFuturo ? 'Os envios só começam em ' + formatDataSP(iniciaEm) + '.\n\n' : '')
      + (editando
        ? 'A campanha passa a mandar ' + (somenteTexto ? 'este texto' : 'este fly') + ' para '
          + vaoReceber + ' contato(s) ' + etq + ' que ainda não receberam'
          + (jaNaCampanha > 0 ? ' — os ' + jaNaCampanha + ' que já receberam ficam como estão' : '')
          + (iniciar ? (inicioFuturo ? ', a partir de ' + formatDataSP(iniciaEm) : ', a partir de agora') : ', depois de retomada')
          + '. '
        : vaoReceber + ' contato(s) ' + etq + (iniciar ? ' vão receber ' : ' vão receber, depois de retomada, ')
          + (somenteTexto ? 'este texto' : 'este fly') + ', ')
      + 'no ritmo de até ' + teto + ' por dia'
      + (diasEstimados && diasEstimados > 1 ? ' — cerca de ' + diasEstimados + ' dias de loja aberta.' : '.')
      + (!editando
        ? '\n\nNo dia em que a lista acabar, se ainda não tiverem saído ' + teto
          + ', o sistema completa com contatos sem etiqueta (inclusive quem nunca falou com a loja), só naquele dia.'
        : '')
      + (resgatados.size > 0
        ? '\n\n' + resgatados.size + ' deles estavam fora e você marcou para receber mesmo assim.'
        : '')
      + (desmarcados.size > 0 ? '\n\n' + desmarcados.size + ' você desmarcou — esses não recebem.' : '')
      // A truncagem tambem entra na confirmacao (decisao 5): truncar calado e' proibido, e o
      // ultimo lugar antes do disparo e' esta frase.
      + (avisoTruncamento ? '\n\n' + avisoTruncamento.fora + ' produto(s) ficam de fora desta combinação — o fly leva no máximo ' + avisoTruncamento.entram + '.' : ''),
      iniciar
        ? { titulo: 'Salvar e publicar?', textoConfirmar: 'Salvar e publicar' }
        : editando
          ? { titulo: 'Salvar as alterações?', textoConfirmar: 'Salvar pausada' }
          : { titulo: 'Salvar sem enviar?', textoConfirmar: 'Salvar pausada' },
    );
    if (!ok) return;
    setEnviando(true);
    try {
      const corpo = {
        nome: nome.trim(),
        inicia_em: iniciaEm,
        etiqueta_ids: etiquetaIds,
        produto_ids: produtoIdsFinal,
        fly_salvo_id: flySalvoIdFinal,
        texto: texto.trim() || null,
        incluir_frios: incluirFrios,
        somente_texto: somenteTexto,
        enviar: chavesAEnviar,
        resgatar: [...resgatados],
        iniciar,
      };
      let r: { id: number; enfileirados: number; status: string };
      if (editando) {
        r = await api.put<{ id: number; enfileirados: number; status: string }>('/api/campanhas-fly/' + editando.id, corpo);
        toast.sucesso(r.status === 'ativa'
          ? 'Campanha publicada: ' + contar(r.enfileirados, 'contato') + ' na fila.'
          : 'Campanha salva pausada: ' + contar(r.enfileirados, 'contato') + ' na fila. Nada foi enviado.');
      } else {
        r = await api.post<{ id: number; enfileirados: number; status: string }>('/api/campanhas-fly', corpo);
        toast.sucesso(r.status === 'pausada'
          ? 'Campanha salva pausada: ' + contar(r.enfileirados, 'contato') + ' na fila. Nada foi enviado.'
          : 'Campanha criada: ' + contar(r.enfileirados, 'contato') + ' na fila.');
      }
      await carregarPainel();
      if (r.status === 'pausada') {
        // So' SALVAR fica onde ele estava (pedido dele, 23/09/2026: "salvar e continuar onde
        // estava") — editando a campanha que acabou de gravar, inclusive a recem-criada. A foto
        // do formulario se refaz sozinha no proximo render, entao o Salvar apaga ate a proxima mudanca.
        setEditando({ id: r.id, nome: nome.trim() });
        setAssinaturaInicial(null);
        restauradoDiferente.current = false;
      } else {
        // Publicada (ativa nao se edita) ou concluida sem ninguem na fila: vai pro painel.
        limparFormulario();
        setVista('andamento');
      }
    } catch (e) {
      toast.erro((e as Error).message || 'não consegui criar a campanha');
    } finally {
      setEnviando(false);
    }
  }

  async function agir(c: CampanhaLinha, acao: 'pausar' | 'retomar' | 'cancelar') {
    if (acao === 'cancelar') {
      const ok = await dialog.confirmar(
        'O que já foi enviado continua enviado. Os ' + c.pendentes + ' que ainda não saíram não sairão mais.',
        { titulo: 'Cancelar a campanha?', perigoso: true, textoConfirmar: 'Cancelar a campanha' },
      );
      if (!ok) return;
    }
    try {
      await api.patch('/api/campanhas-fly/' + c.id, { acao });
      await carregarPainel();
    } catch (e) {
      toast.erro((e as Error).message || 'não consegui mudar a campanha');
    }
  }

  /**
   * Grava os tres parametros de uma vez (aba Configuracoes, 21/09/2026).
   *
   * ⚠️ Repoe o rascunho com o que o SERVIDOR devolveu, nunca com o que foi enviado: o intervalo
   * e' normalizado la' (com a grade de 5, ate 07/10/2026, 33 virava 35). Ecoar a entrada
   * deixaria o campo dizendo um numero enquanto o gotejo pratica outro — a tela mentindo sobre o motor.
   */
  async function salvarParametros(p: ParametrosEnvio) {
    setSalvandoConfig(true);
    try {
      const r = await api.put<{ parametros: ParametrosEnvio }>('/api/campanhas-fly/parametros', p);
      setConfig(r.parametros);
      await carregarPainel();
      // A previa mostra "a N por dia, isso leva X dias" — ela depende do teto, entao tem que
      // ser refeita aqui. Sem isto, o numero da direita segue respondendo pelo teto anterior.
      if (temEtiqueta) {
        setPrevia(await api.post<Previa>('/api/campanhas-fly/previa', {
          etiqueta_ids: etiquetaIds, incluir_frios: incluirFrios,
          ...(editando ? { campanha_id: editando.id } : {}),
        }));
      }
      toast.sucesso('Parâmetros de envio salvos.');
    } catch (e) {
      toast.erro((e as Error).message || 'não consegui salvar os parâmetros');
    } finally {
      setSalvandoConfig(false);
    }
  }

  const emAndamento = (painel?.campanhas ?? []).filter((c) => c.status === 'ativa' || c.status === 'pausada');

  /** Abre/fecha a gaveta de uma campanha, buscando as linhas no clique. */
  async function alternarGavetaCampanha(id: number) {
    if (gavetaCampanha === id) { setGavetaCampanha(null); return; }
    setGavetaCampanha(id);
    setLinhasCampanha(null);
    setCarregandoGaveta(true);
    try {
      const r = await api.get<{ enviados: Recebeu[] }>('/api/campanhas-fly/' + id + '/enviados');
      setLinhasCampanha(r.enviados);
    } catch {
      setLinhasCampanha([]);
    } finally {
      setCarregandoGaveta(false);
    }
  }

  /** A gaveta do CONTADOR DO DIA — so' a campanha, que e' o que o teto conta desde 23/09/2026. */
  async function alternarGavetaDia() {
    if (gavetaDia) { setGavetaDia(false); return; }
    setGavetaDia(true);
    setLinhasDia(null);
    setCarregandoGaveta(true);
    try {
      const r = await api.get<{ enviados: Recebeu[] }>('/api/campanhas-fly/enviados-hoje');
      setLinhasDia(r.enviados);
    } catch {
      setLinhasDia([]);
    } finally {
      setCarregandoGaveta(false);
    }
  }

  /**
   * Enquanto houver campanha CORRENDO, o painel se relê sozinho a cada 30s.
   *
   * ⛔ Sem isto o contador da linha fica parado no numero da abertura, e ele bateu exatamente
   * nisso em 21/09/2026: a tela dizia "0 de 50 enviados" com a primeira mensagem ja entregue.
   * Campanha andando com placar congelado e' o "agi e nada mudou" do principio 1.
   *
   * ⚠️ Recarga de FUNDO: chama o `carregarPainel` silencioso, que nao acende spinner nem
   * desmonta nada ([DA-298]) — se acendesse, a tela piscaria de 30 em 30 segundos sozinha.
   * E a gaveta aberta nao e' tocada: ela tem o proprio botao.
   */
  const temCorrendo = (painel?.campanhas ?? []).some((c) => c.status === 'ativa');

  /**
   * O gotejo esta MESMO acontecendo agora? Loja aberta E dentro da faixa.
   *
   * ⚠️ A hora sai do relogio do NAVEGADOR, e o worker usa o da VPS — as duas estao no mesmo
   * fuso, mas podem divergir por alguns segundos. Isto e' um SELO informativo, nunca uma trava:
   * quem decide se manda e' o servidor, e ele confere de novo a cada tique.
   */
  const gotejando = (() => {
    if (!painel?.loja_aberta) return false;
    const p = painel.parametros;
    if (!p?.janela_ativa) return true;
    const agora = new Date().toTimeString().slice(0, 5);
    return agora >= p.janela_inicio && agora <= p.janela_fim;
  })();

  /**
   * Quanto ainda sai HOJE (pedido dele, 15/10/2026, com print apontando o selo "Faltam"). E' o
   * menor de tres: a cota que sobra do teto, a fila das campanhas ativas e — com a faixa ligada —
   * quantos envios o ritmo medio ainda encaixa ate o fim dela. So' a terceira e' estimativa
   * (o intervalo e' sorteado), e e' por isso que o selo leva "~" quando e' ela quem manda.
   * ⚠️ A cota e' GLOBAL: com duas ativas, as duas disputam o mesmo numero.
   */
  const saiHoje = (() => {
    if (!painel?.loja_aberta) return { n: 0, estimado: false };
    const p = painel.parametros;
    const fila = (painel.campanhas ?? []).filter((c) => c.status === 'ativa').reduce((s, c) => s + c.pendentes, 0);
    const cota = Math.max(0, painel.teto_diario - painel.enviados_hoje);
    let n = Math.min(fila, cota);
    let estimado = false;
    if (p?.janela_ativa) {
      const agora = new Date().toTimeString().slice(0, 5);
      const desde = agora > p.janela_inicio ? agora : p.janela_inicio;
      const minutos = minutosEntreHoras(desde, p.janela_fim);
      const media = (p.intervalo_min + p.intervalo_max) / 2;
      const cabem = minutos < 0 || media <= 0 ? 0 : Math.floor(minutos / media);
      if (cabem < n) { n = cabem; estimado = true; }
    }
    return { n, estimado };
  })();
  useEffect(() => {
    if (vista !== 'andamento' || !temCorrendo) return;
    const t = setInterval(() => { void carregarPainel(); }, 30_000);
    return () => clearInterval(t);
  }, [vista, temCorrendo, carregarPainel]);

  /**
   * A busca de produtos — UMA peca, usada pelos DOIS modos desde 21/09/2026.
   *
   * ⛔ Nao duplicar por modo: o que muda entre texto e arte e' so' o motivo da recusa, e ele ja
   * mora no `motivoDoBloqueio`. Duas copias com a mesma cara divergiriam no primeiro ajuste
   * ([DA-591]) — e aqui a divergencia sairia cara, porque e' a porta de escolher o que o
   * cliente recebe.
   */
  const buscaDeProdutos = (
    <>
      <div style={{ position: 'relative', marginBottom: 6 }}>
        <Search size={16} style={{ position: 'absolute', left: 8, top: '50%', transform: 'translateY(-50%)', color: 'var(--text-muted)' }} />
        {/* 14px em PIXEL e campo mais alto (pedido dele, 07/10/2026) — `text-xs` rendia 10,5. */}
        <input
          value={buscaAdHoc}
          onChange={(ev) => setBuscaAdHoc(ev.target.value)}
          placeholder="Buscar produto por nome ou código..."
          className="w-full pl-8 py-[6px] rounded border text-[14px]"
          style={{ backgroundColor: 'var(--panel-bg)', borderColor: 'var(--border)', color: 'var(--text)' }}
        />
      </div>
      <div className="rounded border" style={{ borderColor: 'var(--border)', maxHeight: 220, overflowY: 'auto' }}>
        {carregandoBuscaAdHoc ? (
          <div className="flex justify-center py-3"><Loader2 size={16} className="animate-spin" style={{ color: 'var(--text-muted)' }} /></div>
        ) : produtosBuscaAdHoc.length === 0 ? (
          <div className="text-xs px-2 py-2" style={{ color: 'var(--text-muted)' }}>
            {buscaAdHoc.trim() ? 'Nada com esse termo.' : 'Digite pra buscar um produto.'}
          </div>
        ) : produtosBuscaAdHoc.map((p) => {
          const sel = produtosAdHoc.some((x) => x.id === p.id);
          const motivo = sel ? null : motivoDoBloqueio(p);
          const rotulos = sel ? [] : rotulosDoBloqueio(p);
          return (
            <button
              key={p.id}
              type="button"
              onClick={() => alternarProdutoAdHoc(p)}
              title={motivo ?? undefined}
              className="w-full text-left px-2 py-1 text-xs flex items-center gap-2"
              style={{
                backgroundColor: sel ? '#fde68a' : 'transparent', border: 'none',
                color: sel ? '#000' : motivo ? 'var(--text-muted)' : 'var(--text)',
                /**
                 * ⛔ O `opacity: 0.6` da linha bloqueada SAIU junto com a entrada do selo escrito.
                 * Ele apagava a linha INTEIRA — inclusive o aviso que agora carrega a informacao,
                 * e a foto que ele pediu pra ver. O "nao serve" continua dito de duas formas: a
                 * cor apagada do texto (`--text-muted`, que ja estava aqui) e o selo, que diz o
                 * motivo com todas as letras em vez de depender do mouse parado em cima.
                 */
                cursor: 'pointer',
              }}
            >
              {/**
                * ⚠️ O ICONE DE ESTADO NAO SAIU — a foto entrou no lugar so' do `Package`, que era
                * marcador neutro. O `Check` e o `AlertTriangle` AFIRMAM algo (escolhido / nao
                * serve pra este modo), e no dia da medicao **4 dos 7** resultados de `CLORO`
                * estavam bloqueados por falta de Descricao Comercial: trocar o sinal pela foto
                * apagaria o unico aviso visivel ([DA-202]).
                * O espaco fica RESERVADO mesmo sem icone, senao a coluna de fotos dança conforme
                * a linha tenha ou nao estado.
                */}
              <span style={{ width: 13, flexShrink: 0, display: 'flex', alignItems: 'center' }}>
                {sel ? <Check size={13} /> : motivo ? <AlertTriangle size={13} /> : null}
              </span>
              {/**
                * A FOTO (pedido dele em 23/09/2026, com o print da busca do orcamento como
                * referencia — mesma forma: miniatura + codigo em `font-mono` azul + descricao).
                * ⚠️ 40px foi ESCOLHA DELE entre 28 e 40, com o custo medido na tela: a linha vai
                * de 21px pra 47px, entao a caixa de 220px mostra 4 resultados de cada vez em vez
                * de 10. Em 28px a embalagem vira mancha, e boa parte do catalogo e' material
                * eletrico cinza.
                * Por que ela importa: `200G PASTILHA CLORO ASTRAL POOL` e `200G PASTILHA CLORO
                * MULTIACAO 3X1` saem na lista com a MESMA descricao comercial (`Genco Tablete
                * Multipla Acao 3 Em 1 200g`) — sao produtos diferentes e so' a foto os separa.
                * O vazio quase nao existe (1.501 de 1.501 ativos com preco tem foto), mas o
                * placeholder mantem a largura pra lista nao desalinhar.
                */}
              {p.foto_url
                ? <FotoProduto url={p.foto_url} tam={40} style={{ flexShrink: 0 }} />
                : <Package size={40} strokeWidth={1} style={{ flexShrink: 0, color: 'var(--text-muted)' }} />}
              {/* Sem `flex-1`: o estoque vem COLADO ao nome (onde ele marcou no print, 25/09/2026), e
                  quem empurra o preco pra direita e' o `marginLeft: auto` dele. */}
              <span className="truncate" style={{ minWidth: 0 }}>
                {p.codigo_interno && (
                  /**
                   * ⚠️ Na linha SELECIONADA a classe SAI — nao basta um `style` por cima dela.
                   * `.text-blue-600` no `styles.css` e' `color: var(--primary) !important` (Fase
                   * 3b, o acento unificado), entao ela vence o inline; e `--primary` segue o tema
                   * enquanto o fundo do selecionado e' `#fde68a` CRAVADO. Medido na tela
                   * publicada: no escuro dava **2,62:1** com o `style` presente e ignorado, e nos
                   * temas Cobre seria ambar sobre amarelo. Sem a classe, o hex vale: **5,38:1**.
                   * Fundo fixo pede fonte fixa — o proprio comentario daquela secao do CSS avisa
                   * que hex inline e' o que fica fora do alcance dela.
                   */
                  // 12px em PIXEL, nao classe `text-*` (rem): pedido dele em 23/09/2026, de 10,5 pra 12.
                  <span className={sel ? 'font-mono text-[12px] mr-2' : 'font-mono text-[12px] text-blue-600 mr-2'} style={sel ? { color: '#1d4ed8' } : undefined}>
                    {p.codigo_interno}
                  </span>
                )}
                {/**
                  * O impedimento ESCRITO, ANTES do nome do produto (pedido dele em 23/09/2026:
                  * *"exibir NA FRENTE de cada produto"*, repetido depois que eu o pus do outro
                  * lado — *"nao apareceu na frente da descricao"*).
                  * ⚠️ Fica DENTRO do `truncate` de proposito: assim ele divide a largura com o
                  * nome em vez de roubar dela por fora. Vindo primeiro, quem corta no aperto e' a
                  * descricao — e' o certo, porque o nome ainda se le pelo codigo e pela foto ao
                  * lado, e o aviso nao se le pela metade.
                  * ⚠️ Sem fundo proprio, borda em `currentColor`: linha bloqueada nunca esta
                  * selecionada (`motivo` so' existe com `sel` falso), entao o fundo e' sempre o do
                  * painel e o par segue o tema — nada de cor fixa contra fundo variavel.
                  * ⚠️ Um selo POR impedimento ([DA-742]): no modo imagem o produto pode faltar foto
                  * E Descricao Comercial, e juntar os dois numa frase so' esconderia que resolver
                  * um nao basta.
                  */}
                {rotulos.map((rotulo) => (
                <span
                  key={rotulo}
                  className="text-[10px] rounded px-1 mr-2"
                  /**
                   * ⚠️ Cor CRAVADA no token cheio, nao herdada. Medido na tela publicada: herdando
                   * o `--text-muted` da linha bloqueada (3,93:1) e com `opacity: 0.85` por cima,
                   * o selo saia em **3,08:1** — reprova, e ele existe exatamente pra ser lido. O
                   * aviso ficar mais forte que o nome do produto e' o certo aqui: o nome apagado
                   * diz "nao serve", o selo diz por que.
                   *
                   * ⛔ E o token e' `--text-color`, NAO `--text`: este arquivo usa `var(--text)`
                   * em varios pontos e ele **nao existe** no `styles.css` (medido na tela: string
                   * vazia no `:root`, no `body` e aqui). Onde parece funcionar, o que resolve e'
                   * a HERANCA da cor do modal — e dentro de uma linha apagada a heranca entrega
                   * justamente o muted, que era o defeito. Variavel inexistente nao da erro: ela
                   * some e o elemento herda.
                   */
                  style={{ color: 'var(--text-color)', border: '1px solid currentColor', whiteSpace: 'nowrap' }}
                >
                  {rotulo}
                </span>
                ))}
                {p.descricao}
              </span>
              {/**
                * O ESTOQUE (pedido dele em 25/09/2026, na criacao e na edicao da campanha). Mesmo
                * texto e mesma formatacao do chat ([DA-707]): informa, NAO trava — a casa vende sem
                * estoque desde a [DA-329]. Fora do `truncate`: nome longo corta, o estoque nao.
                */}
              {p.estoque !== undefined && (
                <span className="tabular-nums" style={{ fontWeight: 700, whiteSpace: 'nowrap', flexShrink: 0 }}>
                  {Number(p.estoque) > 0 ? `${fmtEstoque(p.estoque)} em estoque` : 'sem estoque'}
                </span>
              )}
              <span className="tabular-nums" style={{ fontWeight: 700, marginLeft: 'auto', flexShrink: 0 }}>R$ {Number(p.preco_pix).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
            </button>
          );
        })}
      </div>
    </>
  );

  // Decisao 6: produto sem Descricao Comercial, a tela APONTA — nao remove. UMA peca pros tres
  // lugares onde a lista aparece (texto puro, combinacao escolhida aqui, fly guardado — [DA-742]).
  const avisoSemComercial = produtosSemComercial.length > 0 && (
    <div
      className="text-xs px-2 py-2 rounded border mb-2"
      style={{ borderColor: '#f97316', backgroundColor: '#f97316', color: '#000' }}
    >
      <div className="flex items-center gap-1 font-semibold">
        <AlertTriangle size={13} /> Sem Descrição Comercial — não entram na campanha:
      </div>
      <ul style={{ marginTop: 3, paddingLeft: 18, listStyle: 'disc' }}>
        {produtosSemComercial.map((p) => <li key={p.id}>{p.descricao}</li>)}
      </ul>
      {somenteTexto || usandoAdHocEmImagem
        ? 'Preencha na aba Catálogo de cada produto, ou tire da lista abaixo.'
        : 'Preencha na aba Catálogo de cada produto, ou troque de fly.'}
    </div>
  );

  const rodape = (
    <div className="flex items-center justify-between gap-3 w-full" style={{ paddingRight: 170 }}>
      <div className="text-xs" style={{ color: 'var(--text-muted)' }}>
        {vista === 'nova' && faltandoRodape.length > 0 && <>Falta: {faltandoRodape.join(' · ')}</>}
        {vista === 'nova' && faltandoRodape.length === 0 && previa && (
          <>Vai sair para <strong>{vaoReceber}</strong> contato(s), até {teto} por dia.</>
        )}
        {/* Salvar apagado na edicao sem mudanca tambem DIZ por que (CLAUDE.md § UI). */}
        {vista === 'nova' && editando && faltando.length === 0 && !alterado && (
          <div>Salvar acende quando você alterar alguma coisa.</div>
        )}
      </div>
      <div className="flex items-center gap-2">
        <button type="button" className="btn-secundario" onClick={onFechar}>Fechar</button>
        {vista === 'nova' && (
          // ⚠️ `btn-primario`, nao `btn-secundario`: o secundario nao tem estilo de APAGADO, entao
          // habilitado e apagado eram identicos — e ao lado do "Salvar e publicar" apagado (que
          // esmaece) o Salvar vivo parecia o morto (23/09/2026, print dele: "nao habilitou").
          <button
            type="button"
            className="btn-primario flex items-center gap-1"
            disabled={!podeSalvar}
            onClick={() => void disparar(false)}
            title="A campanha fica pausada — nada é enviado até você clicar em Retomar"
          >
            <Save size={14} /> {editando ? 'Salvar alterações' : 'Salvar sem enviar'}
          </button>
        )}
        {vista === 'nova' && (
          <button
            type="button"
            className="btn-primario flex items-center gap-1"
            disabled={!podePublicar}
            onClick={() => void disparar(true)}
          >
            {enviando ? <Loader2 size={14} className="animate-spin" /> : <Megaphone size={14} />}
            Salvar e publicar
          </button>
        )}
      </div>
    </div>
  );

  return (
    <Modal
      aberto
      telaCheia
      onFechar={onFechar}
      titulo="Campanha de fly por etiqueta"
      rodape={rodape}
      // ⛔ `overflow: hidden` e' assumir o dever de caber: as duas listas tem rolagem propria, e
      // sem isto a pagina inteira rola junto — o defeito que custou tres publicacoes na [DA-671].
      // A altura vem do flex, nunca de `vh`: constante em CSS reserva folga, ela nao mede.
      bodyStyle={{ overflow: 'hidden', display: 'flex', flexDirection: 'column' }}
    >
      <div className="flex items-center gap-2 mb-3 flex-wrap" style={{ flex: '0 0 auto' }}>
        {/* ⛔ ABA, nunca `btn-primario`. Pintada como botao de acao, a aba ATIVA promete um gesto
            que nao existe: ele clicou em "Nova campanha" esperando iniciar a criacao, nada
            aconteceu (a vista ja era essa) e ele reabriu o modal tres vezes em dois minutos.
            O `.aba-btn` da casa (CaixaPainel, Fiscal, ParceiroPrograma) nao promete acao — e
            quem cria e' o botao do rodape, que por isso passou a dizer o que faz. */}
        <button
          type="button"
          className={`aba-btn ${vista === 'nova' ? 'aba-btn-ativo' : ''}`}
          aria-current={vista === 'nova' ? 'page' : undefined}
          onClick={() => setVista('nova')}
        >
          {editando ? 'Editando campanha' : 'Nova campanha'}
        </button>
        {/* A saida da edicao fica na BARRA DE ABAS, que toda janela mostra — no formulario ela
            dependeria de rolagem. Desistir nao grava nada: a campanha segue como estava. */}
        {editando && (
          <button
            type="button"
            className="btn-secundario text-xs flex items-center gap-1"
            title="Volta sem gravar — a campanha continua como estava"
            onClick={() => { limparFormulario(); setVista('andamento'); }}
          >
            <X size={12} /> Desistir da edição
          </button>
        )}
        <button
          type="button"
          className={`aba-btn ${vista === 'andamento' ? 'aba-btn-ativo' : ''}`}
          aria-current={vista === 'andamento' ? 'page' : undefined}
          onClick={() => { setVista('andamento'); void carregarPainel(); }}
        >
          Em andamento ({emAndamento.length})
        </button>
        <button
          type="button"
          className={`aba-btn ${vista === 'config' ? 'aba-btn-ativo' : ''}`}
          aria-current={vista === 'config' ? 'page' : undefined}
          onClick={() => {
            // O rascunho nasce do que ESTA gravado, na hora de abrir — nunca de um estado que
            // ficou pra tras de uma visita anterior.
            if (painel) setConfig({ ...painel.parametros });
            setVista('config');
          }}
        >
          Configurações
        </button>

        {/* O estado do gotejo fica SEMPRE visivel, nas tres vistas: sem ele, uma campanha parada
            porque a loja fechou ou porque o teto bateu le como campanha quebrada. */}
        {painel && (
          <span className="ml-auto flex items-center gap-3 text-xs" style={{ color: 'var(--text-muted)' }}>
            <span className="flex items-center gap-1">
              {/* O "+" que diz QUEM sao — pedido dele em 21/09/2026: o contador sozinho conta a
                  cota gasta e esconde por quem. Desde 23/09/2026 o teto conta so' a campanha,
                  e a lista acompanha. */}
              <button
                type="button"
                className="btn-icon"
                onClick={() => void alternarGavetaDia()}
                aria-label={gavetaDia ? 'Recolher quem recebeu hoje' : 'Ver quem recebeu hoje'}
                title={gavetaDia ? 'Recolher' : 'Ver quem recebeu hoje'}
              >
                {gavetaDia ? <Minus size={13} /> : <Plus size={13} />}
              </button>
              Hoje já saíram <strong className="tabular-nums" style={{ color: 'var(--num-destaque)' }}>
                {painel.enviados_hoje}
              </strong> de {painel.teto_diario}
            </span>
            {/* ⛔ TRES estados, nao dois. Ate 21/09/2026 este selo dizia "gotejando" sempre que a
                loja estivesse aberta — e no dia em que a FAIXA de horario entrou, ele passou a
                afirmar que a campanha estava andando com ela parada fora da faixa. Ele perdeu
                meia hora achando que o disparo tinha quebrado. Motivo de parada que a tela nao
                nomeia le como defeito ([DA-360]/principio 1). */}
            <span
              className="px-2 py-0.5 rounded"
              style={{
                backgroundColor: gotejando ? '#fde68a' : (painel.loja_aberta ? '#f97316' : 'transparent'),
                color: gotejando ? '#000' : (painel.loja_aberta ? '#000' : 'var(--text-muted)'),
                border: (gotejando || painel.loja_aberta) ? 'none' : '1px solid var(--border)',
              }}
            >
              {!painel.loja_aberta ? 'loja fechada — nada sai agora'
                : gotejando ? 'loja aberta — gotejando'
                  : 'fora da faixa — volta às ' + painel.parametros.janela_inicio}
            </span>
            {/* ⚠️ O teto continua VISIVEL aqui (no "de {teto}" acima) mesmo tendo virado campo da
                aba Configuracoes: ele e' o estado que ele precisa no instante de decidir disparar.
                O que saiu daqui foi o CAMPO — porque editar um parametro GLOBAL na tela de criar
                UMA campanha fazia parecer que ele era daquela campanha. */}
            <button
              type="button"
              className="underline"
              style={{ color: 'var(--primary)' }}
              onClick={() => { if (painel) setConfig({ ...painel.parametros }); setVista('config'); }}
            >
              mudar o ritmo
            </button>
          </span>
        )}
      </div>

      {/* A gaveta do DIA — fica FORA da barra de abas, abaixo dela, porque a barra e' uma linha
          flex e um painel dentro dela empurraria os selos pro lado. Vale nas tres vistas: a
          pergunta "quem gastou a cota de hoje?" nao muda de aba. */}
      {gavetaDia && (
        <div
          className="mb-3 rounded border"
          style={{ borderColor: 'var(--border)', backgroundColor: 'var(--panel-bg)', flex: '0 0 auto' }}
        >
          <div
            className="px-2 py-1 text-xs font-semibold"
            style={{ borderBottom: '1px solid var(--border)' }}
          >
            Quem recebeu fly hoje
          </div>
          <GavetaRecebeu
            linhas={linhasDia}
            carregando={carregandoGaveta}
            vazio="Nenhum fly saiu hoje ainda — nem pela campanha, nem pelo chat."
            agrupar
          />
        </div>
      )}

      {vista === 'nova' ? (
        <div
          className="grid gap-4"
          style={{ gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)', flex: '1 1 auto', minHeight: 0 }}
        >
          {/* ── ESQUERDA: o que mandar ── */}
          <div className="flex flex-col gap-3" style={{ minHeight: 0, overflowY: 'auto', paddingRight: 4 }}>
            <div className="flex gap-3 items-end">
              <label className="text-sm" style={{ flex: '1 1 auto', minWidth: 0 }}>
                <div className="mb-1 font-semibold">Nome da campanha</div>
                {/* MAIUSCULO no valor, nao so' no CSS (pedido dele, 25/09/2026): o campo ja
                    MOSTRAVA maiusculo e gravava "solar". O servidor tambem converte. */}
                <input
                  value={nome}
                  onChange={(ev) => setNome(ev.target.value.toUpperCase())}
                  placeholder="Como você vai reconhecer esta campanha depois"
                  maxLength={80}
                  className="w-full px-2 py-1 rounded border"
                  style={{ backgroundColor: 'var(--panel-bg)', borderColor: 'var(--border)', color: 'var(--text)' }}
                />
              </label>
              {/* A DATA INICIAL do disparo (pedido dele, 25/09/2026; migration 0298). Nasce hoje;
                  com data futura a campanha pode estar publicada e nada sai ate o dia. */}
              <label className="text-sm" style={{ flex: '0 0 auto' }}>
                <div className="mb-1 font-semibold">Início do disparo</div>
                <input
                  type="date"
                  value={iniciaEm}
                  onChange={(ev) => setIniciaEm(ev.target.value)}
                  className="px-2 py-1 rounded border"
                  style={{ backgroundColor: 'var(--panel-bg)', borderColor: 'var(--border)', color: 'var(--text)' }}
                />
              </label>
            </div>

            {/* ⚠️ Decisao dele, 21/09/2026: a MESMA campanha, com um botao "Somente Texto" — a
                mensagem chega como texto puro (lista de precos), sem arte. Nasce DESLIGADO. */}
            <Interruptor
              ligado={somenteTexto}
              onChange={alternarSomenteTexto}
              rotuloLigado="Somente texto"
              rotuloDesligado="Fly com imagem"
              ajuda={somenteTexto
                ? 'a mensagem sai como texto puro — sem imagem, sem limite de produtos'
                : 'a mensagem sai com a arte de sempre — escolha os produtos ou um fly guardado'}
            />

            {avisoTruncamento && (
              // ⚠️ Decisao 5: truncar calado e' proibido — o aviso fica visivel ate ele resolver.
              <div
                className="flex items-start gap-2 text-xs px-2 py-2 rounded border"
                style={{ borderColor: '#f97316', backgroundColor: '#f97316', color: '#000' }}
              >
                <AlertTriangle size={14} style={{ flex: '0 0 auto', marginTop: 1 }} />
                <span>
                  Desligando o texto puro, o fly leva no máximo <strong>{avisoTruncamento.entram}</strong> produtos —
                  os <strong>{avisoTruncamento.fora}</strong> últimos ficaram de fora desta combinação.
                </span>
              </div>
            )}

            {somenteTexto ? (
              /* ── PICKER AD-HOC (Somente Texto): busca direto, sem teto (decisao 2) ── */
              <div className="text-sm">
                <div className="mb-1 font-semibold flex items-center justify-between">
                  <span>Produtos (escolha quantos quiser)</span>
                  <span className="text-xs" style={{ color: 'var(--text-muted)', fontWeight: 400 }}>
                    {contar(produtosAdHoc.length, 'produto')} escolhido{produtosAdHoc.length === 1 ? '' : 's'}
                  </span>
                </div>

                {avisoSemComercial}

                {produtosAdHoc.length > 0 && (
                  <div className="flex flex-wrap gap-1 mb-2">
                    {produtosAdHoc.map((p) => (
                      <span
                        key={p.id}
                        className="inline-flex items-center gap-1 text-xs rounded"
                        style={{
                          padding: '2px 4px 2px 2px',
                          backgroundColor: avisoDescricao.some((f) => f.id === p.id) ? '#f97316' : '#fde68a',
                          color: '#000',
                        }}
                      >
                        {fotoDoChip(p)}
                        {p.descricao}
                        {estoqueDoChip(p)}
                        <button
                          type="button"
                          onClick={() => alternarProdutoAdHoc(p)}
                          title={'Tirar ' + p.descricao}
                          style={{ display: 'flex', color: '#000', border: 'none', background: 'transparent', cursor: 'pointer' }}
                        >
                          <X size={12} />
                        </button>
                      </span>
                    ))}
                  </div>
                )}

                {buscaDeProdutos}
              </div>
            ) : (
              /* ── FLY COM IMAGEM: a busca e os flys guardados, os DOIS a vista ([DA-743]) ──
                 Pedido dele, 23/09/2026: *"Gostaria que todos os campos ficassem visiveis, dessa
                 forma nao precisaria do botao Escolher Produto"*. Ate aqui a secao era UMA de duas
                 vistas trocadas por botao (lista de flys OU busca), e a busca com a arte embaixo
                 empurrava a etiqueta pra fora da tela. ⛔ O que vale e' o ULTIMO gesto: escolher
                 um fly larga a combinacao da busca, e marcar um produto larga o fly — e a escolha
                 em vigor fica pintada de amarelo, pra nunca haver duvida de qual das duas sai. */
              <div className="text-sm flex flex-col gap-3">
              <div>
                {/* Contador pedido por ele, 23/09/2026 — com 12 escolhidos a conta a olho nao fecha. */}
                <div className="mb-1 font-semibold flex items-center justify-between">
                  <span className="flex items-center gap-2">
                    <span>Produtos do fly</span>
                    {/* "Faltam x produtos" colado no titulo (pedido dele, 10/10/2026, com print) —
                        a frase longa embaixo segue dizendo as duas saidas. Par fixo amarelo/preto. */}
                    {motivoQtdAdHoc && rotuloFaltaFly(produtosAdHoc.length) && (
                      <span className="text-xs font-bold rounded px-2" style={{ backgroundColor: '#fde68a', color: '#000', lineHeight: '18px' }}>
                        {rotuloFaltaFly(produtosAdHoc.length)}
                      </span>
                    )}
                  </span>
                  {!flyEscolhido && produtosAdHoc.length > 0 && (
                    <span className="flex items-center gap-2">
                      <span className="text-xs" style={{ color: 'var(--text-muted)', fontWeight: 400 }}>
                        {contar(produtosAdHoc.length, 'produto')} selecionado{produtosAdHoc.length === 1 ? '' : 's'}
                      </span>
                      {/* ⚠️ `btn-primario`, nao secundario: e' a UNICA porta da ordem, e secundario
                          sozinho num cabecalho some ([DA-667]). So' aparece com 2+ — com um nao ha
                          o que ordenar. */}
                      {produtosAdHoc.length > 1 && (
                        <button type="button" className="btn-primario text-xs flex items-center gap-1" style={{ padding: '3px 10px' }} onClick={() => setOrdemAberta(true)}>
                          <ArrowUpDown size={12} /> Organizar ordem
                        </button>
                      )}
                    </span>
                  )}
                </div>

                {/* A regra da ARTE, dita antes do clique: o quadro comporta 3 lado a lado ou 4x3
                    ([DA-730]). O rodape ja repete isto no "Falta:", mas quem esta escolhendo
                    produto olha pra ca, nao pra la. */}
                <div className="text-xs mb-2" style={{ color: 'var(--text-muted)' }}>
                  {flyEscolhido
                    ? <>Usando o fly guardado <strong>{flyEscolhido.nome}</strong> — marcar um produto aqui troca por uma combinação nova.</>
                    : (motivoQtdAdHoc ?? 'Esta combinação vira fly — a arte está desenhada abaixo.')}
                </div>

                {avisoSemComercial}

                {/* 4 por linha (pedido dele, 23/09/2026: *"este bloco esta confuso"* — com 12 chips
                    de largura livre as linhas quebravam cada uma num ponto e nada alinhava). Nome
                    longo QUEBRA LINHA dentro da etiqueta, nunca corta (pedido dele, 25/09/2026). */}
                {produtosAdHoc.length > 0 && (
                  <div className="grid gap-1 mb-2" style={{ gridTemplateColumns: 'repeat(4, minmax(0, 1fr))' }}>
                    {produtosAdHoc.map((p, i) => (
                      // 14px em PIXEL, nao classe `text-*` (rem — `text-xs` rendia 10,5): pedido dele em 07/10/2026.
                      <span key={p.id} title={p.descricao} className="flex text-[14px] rounded" style={{ padding: '2px 4px', minWidth: 0, backgroundColor: avisoAtivo.some((f) => f.id === p.id) ? '#f97316' : '#fde68a', color: '#000' }}>
                        {/* ⛔ Sem `truncate` (pedido dele em 25/09/2026: *"ainda que precise usar duas
                            linhas, nao trunque a legenda"*) — cortado, `1/2"` e `3/4"` viravam o
                            mesmo "Eletroduto PV...". O nome quebra linha dentro da etiqueta.
                            Tres linhas, todas com a largura inteira da etiqueta (pedidos dele, 07/10/2026,
                            *"para abrir mais espaco para descricao do produto"*): em cima foto + posicao +
                            codigo interno (na cor fixa `#1d4ed8` da busca, porque o fundo aqui tambem e'
                            cravado); no meio a descricao; embaixo o estoque e o X. */}
                        <span style={{ flex: '1 1 auto', minWidth: 0, overflowWrap: 'anywhere', lineHeight: 1.25 }}>
                          <span className="flex items-center gap-1">
                            {fotoDoChip(p)}
                            {/* A posicao no fly — a mesma que a tela de ordem mostra. */}
                            <strong style={{ flex: '0 0 auto' }}>{i + 1}.</strong>
                            {p.codigo_interno && <span className="font-mono" style={{ color: '#1d4ed8' }}>{p.codigo_interno}</span>}
                          </span>
                          <span className="block">{p.descricao}</span>
                          <span className="flex items-center gap-1">
                            {estoqueDoChip(p)}
                            <button type="button" onClick={() => alternarProdutoAdHoc(p)} title={'Tirar ' + p.descricao} style={{ display: 'flex', flex: '0 0 auto', marginLeft: 'auto', color: '#000', border: 'none', background: 'transparent', cursor: 'pointer' }}>
                              <X size={12} />
                            </button>
                          </span>
                        </span>
                      </span>
                    ))}
                  </div>
                )}

                {buscaDeProdutos}
              </div>

              <div>
                <div className="mb-1 font-semibold">Ou use um fly guardado</div>
              {flys.length === 0 ? (
                // ⚠️ Vazio NOMEIA a saida — e a busca logo acima ja e' o caminho curto ([DA-639]).
                <div className="text-xs px-2 py-3 rounded border" style={{ borderColor: 'var(--border)', color: 'var(--text-muted)' }}>
                  Você ainda não guardou nenhum fly. Monte a combinação na busca acima e clique em
                  Salvar este fly, que ele passa a aparecer aqui.
                </div>
              ) : (
                <div className="flex flex-col gap-1" style={{ maxHeight: 260, overflowY: 'auto' }}>
                  {flys.map((f) => {
                    const a = artes[f.id];
                    // O escolhido fica PINTADO na lista, em vez de a lista sumir: com a busca ao
                    // lado, e' o amarelo que diz qual das duas escolhas vai sair ([DA-743]).
                    const escolhido = f.id === flyId;
                    return (
                      <button
                        key={f.id}
                        type="button"
                        onClick={() => escolherFly(f.id)}
                        title={escolhido ? 'Clique de novo para largar este fly' : undefined}
                        className="text-left px-2 py-1.5 rounded border text-xs flex items-center gap-2"
                        style={{
                          borderColor: 'var(--border)',
                          backgroundColor: escolhido ? '#fde68a' : 'transparent',
                          color: escolhido ? '#000' : 'var(--text)',
                        }}
                      >
                        {/* A miniatura E' o reconhecimento: o nome que ele deu ao fly nao diz o que
                            a arte mostra, e era por isso que a lista parecia um rotulo em vez de
                            uma escolha. */}
                        <span
                          className="flex items-center justify-center rounded"
                          style={{ width: 46, height: 46, flex: '0 0 auto', border: '1px solid var(--border)', overflow: 'hidden' }}
                        >
                          {a && a !== 'erro' ? (
                            <img src={a.imagem} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                          ) : a === 'erro' ? (
                            <AlertTriangle size={16} style={{ color: 'var(--text-muted)' }} />
                          ) : desenhando === f.id ? (
                            <Loader2 size={14} className="animate-spin" style={{ color: 'var(--text-muted)' }} />
                          ) : (
                            <ImageIcon size={16} style={{ color: 'var(--text-muted)' }} />
                          )}
                        </span>
                        <span className="flex-1" style={{ minWidth: 0 }}>
                          <strong>{f.nome}</strong>
                          <div className="truncate" style={{ opacity: 0.75 }}>
                            {f.produtos.map((p) => p.descricao).join(' · ')}
                            {f.faltando > 0 && ' · ' + f.faltando + ' produto(s) fora do ar'}
                          </div>
                          {/* [DA-742]: a campanha recusa este fly enquanto faltar a comercial —
                              dizer ANTES do clique, nao depois de escolher. */}
                          {(() => {
                            const n = f.produtos.filter((p) => semComercialFlys.has(p.id)).length;
                            return n > 0 && (
                              <span
                                className="text-[10px] rounded px-1 inline-block mt-0.5"
                                style={{ color: escolhido ? '#000' : 'var(--text-color)', border: '1px solid currentColor', whiteSpace: 'nowrap' }}
                              >
                                {n === f.produtos.length ? 'Sem Descrição Comercial' : `${n} de ${f.produtos.length} sem Descrição Comercial`}
                              </span>
                            );
                          })()}
                        </span>
                      </button>
                    );
                  })}
                </div>
              )}
              </div>

              {/* A ARTE da escolha em vigor, em tamanho de conferir — fly guardado ou combinacao da
                  busca. E' o que faz a campanha deixar de ser aprovada as cegas ([DA-682]).
                  ⛔ So' existe com a quantidade VALIDA (senao "Desenhando..." pra sempre) e sem
                  produto sem Descricao Comercial (o servidor recusa, e o aviso laranja ja diz por
                  que — "nao consegui desenhar" mandaria cacar defeito, [DA-742]). */}
              {(() => {
                const arte = flyEscolhido ? arteEscolhida : arteAdHoc;
                const mostra = flyEscolhido
                  ? semComercialFlyEscolhido.length === 0
                  : produtosAdHoc.length > 0 && !motivoQtdAdHoc && avisoAtivo.length === 0;
                if (!mostra) return null;
                return (
                  <div className="rounded border px-2 py-2" style={{ borderColor: 'var(--border)' }}>
                    {arte && arte !== 'erro' ? (
                      <>
                        <img src={arte.imagem} alt="Fly" style={{ width: '100%', maxWidth: 300, borderRadius: 6, display: 'block', margin: '0 auto' }} />
                        {/* [DA-744]: so' pra combinacao montada aqui — fly guardado ja esta guardado.
                            Colado na arte, que e' o que ele acabou de conferir e quer guardar. */}
                        {!flyEscolhido && (
                          <div className="flex justify-center mt-2">
                            <button
                              type="button"
                              className="btn-primario text-xs inline-flex items-center gap-1"
                              style={{ whiteSpace: 'nowrap' }}
                              onClick={() => void salvarFlyAtual()}
                              disabled={salvandoFly}
                            >
                              {salvandoFly ? <Loader2 size={13} className="animate-spin" /> : null}
                              Salvar este fly
                            </button>
                          </div>
                        )}
                      </>
                    ) : arte === 'erro' ? (
                      <div className="flex items-center gap-1 text-xs" style={{ color: 'var(--text-muted)' }}>
                        <AlertTriangle size={13} /> {flyEscolhido
                          ? 'Não consegui desenhar este fly — algum produto pode ter saído do ar.'
                          : 'Não consegui desenhar esta combinação.'}
                      </div>
                    ) : (
                      <div className="flex items-center gap-2 text-xs" style={{ color: 'var(--text-muted)' }}>
                        <Loader2 size={13} className="animate-spin" /> Desenhando a arte...
                      </div>
                    )}
                  </div>
                );
              })()}
              </div>
            )}

            <div className="text-sm">
              <div className="mb-1 font-semibold">
                Para quais etiquetas{' '}
                <span style={{ color: 'var(--text-muted)', fontWeight: 400 }}>(recebe quem estiver em qualquer uma)</span>
              </div>
              {/* Todas as etiquetas a vista, cada uma liga/desliga com um clique (pedido dele,
                  06/10/2026 — antes era combo + selos). Campanha nova abre com nada marcado.
                  Marcada = cor da etiqueta + check + contorno preto; o check e o contorno
                  carregam o estado sem depender da cor (daltonismo). Desmarcada = par casado
                  do input (fundo e fonte da mesma familia, contraste garantido no tema). */}
              <div className="flex flex-wrap gap-1.5" role="group" aria-label="Etiquetas da campanha">
                {etiquetas.map((e) => {
                  const marcada = etiquetaIds.includes(e.id);
                  const cor = e.cor || '#e2e8f0';
                  return (
                    <button
                      key={e.id}
                      type="button"
                      aria-pressed={marcada}
                      title={marcada ? 'Tirar esta etiqueta da campanha' : 'Incluir esta etiqueta na campanha'}
                      onClick={() => setEtiquetaIds((ids) => (ids.includes(e.id) ? ids.filter((x) => x !== e.id) : [...ids, e.id]))}
                      className="inline-flex items-center gap-1 px-2 py-1 rounded text-xs font-bold"
                      style={marcada
                        ? { backgroundColor: cor, color: corDoTexto(cor), border: '2px solid #000', whiteSpace: 'nowrap' }
                        : { backgroundColor: 'var(--input-bg)', color: 'var(--input-fg)', border: '2px solid var(--input-border)', whiteSpace: 'nowrap', fontWeight: 400 }}
                    >
                      {marcada && <Check size={13} />}
                      {e.nome}
                    </button>
                  );
                })}
              </div>
              {!temEtiqueta && (
                <div className="mt-1 text-xs" style={{ color: 'var(--text-color)' }}>
                  Clique em uma ou mais etiquetas.
                </div>
              )}
            </div>

            <div className="text-sm">
              <div className="mb-1 font-semibold flex items-center justify-between">
                <span>Texto que vai junto <span style={{ color: 'var(--text-muted)', fontWeight: 400 }}>(opcional)</span></span>
                {podeSalvarPadrao && (
                  <button type="button" className="btn-secundario text-xs" onClick={() => void salvarPadrao()}>
                    Salvar como padrão
                  </button>
                )}
              </div>
              <textarea
                value={texto}
                onChange={(ev) => { textoTocado.current = true; setTexto(ev.target.value); }}
                rows={4}
                maxLength={1000}
                placeholder={somenteTexto
                  ? 'Uma linha sua antes da lista de preços. Sem isso, a mensagem leva só os produtos.'
                  : 'Uma linha sua antes dos produtos. Sem isso, o fly leva só o nome, o preço e o código — e o catálogo, só a imagem.'}
                // ⛔ `no-upper` — este texto SAI PRA FORA. O uppercase global do `styles.css` e'
                // regra de cadastro interno, e o proprio CSS ja prevê esta escotilha; sem ela a
                // mensagem chega ao cliente parecendo grito (corte dele, 11/09/2026). A convencao
                // da casa ja dizia "excecao: textos enviados via WhatsApp" — faltava aplicar aqui.
                className="w-full px-2 py-1 rounded border no-upper"
                style={{ backgroundColor: 'var(--panel-bg)', borderColor: 'var(--border)', color: 'var(--text)' }}
              />
              {(painel?.variaveis ?? []).length > 0 && (
                <div className="text-xs mt-1" style={{ color: 'var(--text-muted)' }}>
                  {painel!.variaveis.map((v) => (
                    <div key={v.chave}>
                      {/* "ex.:", nao "hoje:" — as duas sao por pessoa desde a [DA-811]. */}
                      <strong>{v.chave}</strong> — {v.ajuda} (ex.: {v.valor})
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* ⚠️ O QUE O CLIENTE LE, com as variaveis ja trocadas — `@FREQUENCIA` e `@NOME` com
                um EXEMPLO real (o primeiro da lista de quem recebe, [DA-811]). Sem isto ele
                aprova "@FREQUENCIA" e o cliente recebe outra coisa — a previa existe pelo mesmo
                motivo nos dois modos ([DA-591]). */}
            {somenteTexto ? (
              // Modo TEXTO: a mensagem vem PRONTA do servidor (`/mensagem-texto`, a MESMA funcao
              // do envio) — so' falta o exemplo real de `@NOME`, aplicado aqui com a peca
              // compartilhada.
              carregandoMensagemTexto ? (
                <div className="flex items-center gap-2 text-xs" style={{ color: 'var(--text-muted)' }}>
                  <Loader2 size={13} className="animate-spin" /> Montando a mensagem...
                </div>
              ) : erroMensagemTexto ? (
                <div className="flex items-center gap-1 text-xs" style={{ color: 'var(--text-muted)' }}>
                  <AlertTriangle size={13} /> {erroMensagemTexto}
                </div>
              ) : mensagemTextoPrevia ? (
                <div className="text-sm">
                  <div className="mb-1 font-semibold flex items-center gap-1">
                    <TypeIcon size={13} /> Como vai chegar
                  </div>
                  <div
                    className="px-3 py-2 rounded text-xs"
                    style={{ backgroundColor: 'var(--grid-header-bg)', color: 'var(--grid-header-fg)', whiteSpace: 'pre-wrap' }}
                  >
                    {resolverExemplo(mensagemTextoPrevia)}
                  </div>
                </div>
              ) : null
            ) : (
              /* ⚠️ No CATALOGO de 12 a `legenda_produtos` vem vazia (decisao dele, 14/09/2026: so'
                  o texto dele vai junto) — por isso a juncao por partes, e a caixa so' existe
                  quando ha algum texto a mostrar. Usa a arte AD-HOC quando a combinacao nao vem
                  de um fly guardado (sobra de um desligar-com-truncamento). */
              (() => {
                const arteAtual = usandoAdHocEmImagem ? arteAdHoc : arteEscolhida;
                const partes = [
                  textoResolvido.trim(),
                  arteAtual && arteAtual !== 'erro' ? arteAtual.legenda_produtos : '',
                ].filter(Boolean);
                if (partes.length === 0) return null;
                return (
                  <div className="text-sm">
                    <div className="mb-1 font-semibold">Como vai chegar</div>
                    <div
                      className="px-3 py-2 rounded text-xs"
                      style={{ backgroundColor: 'var(--grid-header-bg)', color: 'var(--grid-header-fg)', whiteSpace: 'pre-wrap' }}
                    >
                      {partes.join('\n\n')}
                    </div>
                  </div>
                );
              })()
            )}

            {/* ⛔ NASCE DESMARCADA — decisao dele em 11/09/2026. Nas etiquetas de interesse a
                maioria nunca falou com a loja, e mandar a frio e' o que mais se parece com o que a
                conta foi acusada de fazer. A caixa diz o NUMERO dos dois lados, pra escolha ser
                sobre o dado e nao sobre a palavra. */}
            <label className="flex items-start gap-2 text-sm px-2 py-2 rounded border" style={{ borderColor: 'var(--border)' }}>
              <input
                type="checkbox"
                checked={incluirFrios}
                onChange={(ev) => setIncluirFrios(ev.target.checked)}
                className="mt-0.5"
              />
              <span>
                <strong>Incluir quem nunca falou com a loja</strong>
                <div className="text-xs" style={{ color: 'var(--text-muted)' }}>
                  {previa
                    ? (previa.frios_de_fora > 0
                        ? 'Ligar isto acrescenta ' + previa.frios_de_fora + ' contato(s) a esta campanha.'
                        : incluirFrios
                          ? 'Nesta etiqueta, todo mundo já conversou com a loja — ligar não muda nada.'
                          : 'Nesta etiqueta, todo mundo já conversou com a loja.')
                    : 'Escolha a etiqueta para ver quantos isto acrescenta.'}
                </div>
              </span>
            </label>
          </div>

          {/* ── DIREITA: a previa, agora com nome e caixa ──
              ⚠️ A coluna ROLA INTEIRA e as listas saem completas, sem rolagem propria — escolha
              dele em 24/09/2026 ("achei a lista curta"): as duas caixas repartiam a altura e
              mostravam 5 de 115. "Ficam de fora" fica depois da ultima linha de quem recebe. */}
          <div className="flex flex-col gap-2" style={{ minHeight: 0, overflowY: 'auto' }}>
            {!temEtiqueta ? (
              <div className="text-xs px-2 py-3 rounded border" style={{ borderColor: 'var(--border)', color: 'var(--text-muted)' }}>
                Escolha uma etiqueta e eu listo exatamente quem recebe, quem fica de fora e por quê.
              </div>
            ) : carregandoPrevia ? (
              <div className="flex items-center gap-2 text-xs" style={{ color: 'var(--text-muted)' }}>
                <Loader2 size={14} className="animate-spin" /> Conferindo a lista...
              </div>
            ) : previa ? (
              <>
                <div className="px-3 py-2 rounded border" style={{ borderColor: 'var(--border)', flex: '0 0 auto' }}>
                  <div className="text-sm">
                    <strong className="tabular-nums text-lg" style={{ color: 'var(--num-destaque)' }}>{vaoReceber}</strong>
                    {' '}de {previa.total} contato(s) {etiquetaIds.length > 1
                      ? 'destas ' + etiquetaIds.length + ' etiquetas'
                      : etiquetaIds[0] === SEM_ETIQUETA_ID ? 'sem etiqueta' : 'da etiqueta'} vão receber.
                  </div>
                  {editando && (previa.ja_na_campanha ?? 0) > 0 && (
                    <div className="text-xs mt-0.5" style={{ color: 'var(--text-muted)' }}>
                      <strong>{previa.ja_na_campanha}</strong> já receberam esta campanha e ficam como estão — não aparecem nas listas abaixo.
                    </div>
                  )}
                  {diasEstimados && diasEstimados > 1 && (
                    <div className="text-xs mt-0.5" style={{ color: 'var(--text-muted)' }}>
                      A até {teto} por dia, isso leva cerca de <strong>{diasEstimados} dias</strong> de loja aberta.
                    </div>
                  )}
                  {/* [DA-821]: so' campanha NOVA completa — as antigas, abertas pra editar, nao mudam. */}
                  {!editando && (
                    <div className="text-xs mt-0.5" style={{ color: 'var(--text-muted)' }}>
                      No dia em que esta lista acabar, se ainda não tiverem saído {teto}, o sistema completa com
                      contatos <strong>sem etiqueta</strong> (inclusive quem nunca falou com a loja), com este mesmo
                      fly — só naquele dia.
                    </div>
                  )}
                  {resgatados.size > 0 && (
                    <div className="text-xs mt-0.5" style={{ color: 'var(--text-muted)' }}>
                      Inclui <strong>{resgatados.size}</strong>{' '}
                      {resgatados.size === 1 ? 'que estava de fora e você marcou.' : 'que estavam de fora e você marcou.'}
                    </div>
                  )}
                </div>

                <label
                  className="flex items-center gap-2 px-2 py-1 rounded border text-xs"
                  style={{ borderColor: 'var(--border)', flex: '0 0 auto' }}
                >
                  <Search size={13} style={{ color: 'var(--text-muted)' }} />
                  <input
                    value={filtro}
                    onChange={(ev) => setFiltro(ev.target.value)}
                    placeholder="Procurar por nome ou número nas duas listas"
                    className="flex-1 bg-transparent outline-none"
                    style={{ color: 'var(--text)' }}
                  />
                  {filtro && (
                    <button type="button" onClick={() => setFiltro('')} style={{ color: 'var(--text-muted)' }}>
                      <X size={13} />
                    </button>
                  )}
                </label>

                {/* ── QUEM VAI RECEBER ── */}
                <div className="flex flex-col rounded border" style={{ borderColor: 'var(--border)', flex: '0 0 auto' }}>
                  <div
                    className="flex items-center justify-between gap-2 px-2 py-1 text-xs font-semibold"
                    style={{ borderBottom: '1px solid var(--border)', flex: '0 0 auto' }}
                  >
                    {/* A caixa vem ANTES do texto pra cair na mesma coluna das caixas das linhas
                        (o cabecalho e' a linha tem o mesmo `px-2 gap-2`) — e' o lugar onde ele
                        desenhou no print, e e' onde a mao ja procura numa tabela. */}
                    <span className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        checked={todosVisiveisMarcados}
                        ref={(el) => { if (el) el.indeterminate = algunsVisiveisMarcados; }}
                        disabled={recebemFiltrados.length === 0}
                        onChange={() => marcarTodosVisiveis(!todosVisiveisMarcados)}
                        title={todosVisiveisMarcados ? 'Desmarcar todos os da lista' : 'Marcar todos os da lista'}
                        aria-label={todosVisiveisMarcados ? 'Desmarcar todos os da lista' : 'Marcar todos os da lista'}
                        style={{ cursor: recebemFiltrados.length === 0 ? 'default' : 'pointer' }}
                      />
                      Quem vai receber ({chavesAEnviar.length} de {recebem.length})
                    </span>
                    <span className="flex items-center gap-1">
                      <button type="button" className="btn-secundario text-xs" onClick={() => marcarTodosVisiveis(true)}>
                        Marcar todos
                      </button>
                      <button type="button" className="btn-secundario text-xs" onClick={() => marcarTodosVisiveis(false)}>
                        Desmarcar todos
                      </button>
                    </span>
                  </div>
                  <div>
                    {recebemFiltrados.length === 0 ? (
                      <div className="text-xs px-2 py-2" style={{ color: 'var(--text-muted)' }}>
                        {recebem.length === 0 ? 'Ninguém desta etiqueta pode receber agora.' : 'Nada com esse filtro.'}
                      </div>
                    ) : recebemFiltrados.map((r) => (
                      <LinhaContato
                        key={r.chave}
                        nomeContato={r.nome}
                        chave={r.chave}
                        fotoUrl={r.foto_url}
                        marcado={!desmarcados.has(r.chave)}
                        onToggle={() => alternarRecebe(r.chave)}
                        riscarDesmarcado
                        etiquetasDaLinha={etiquetasDaLinha(r.etiqueta_ids)}
                        motivoDesmarcado={desmarcados.has(r.chave) ? motivoAbertura.get(r.chave) : undefined}
                        ultimoEnvio={r.ultimo_envio}
                        diasUltimoEnvio={r.dias_ultimo_envio}
                        destacado={conversaAberta === r.chave}
                        onAbriuConversa={() => setConversaAberta(r.chave)}
                      />
                    ))}
                  </div>
                </div>

                {/* ── FICAM DE FORA ── */}
                <div className="flex flex-col rounded border" style={{ borderColor: 'var(--border)', flex: '0 0 auto' }}>
                  <div
                    className="px-2 py-1 text-xs font-semibold"
                    style={{ borderBottom: '1px solid var(--border)', flex: '0 0 auto' }}
                  >
                    Ficam de fora ({fora.length})
                  </div>
                  <div>
                    {gruposFora.length === 0 ? (
                      <div className="text-xs px-2 py-2" style={{ color: 'var(--text-muted)' }}>
                        {fora.length === 0 ? 'Ninguém ficou de fora nesta etiqueta.' : 'Nada com esse filtro.'}
                      </div>
                    ) : gruposFora.map(([motivo, g]) => {
                      const todosMarcados = g.linhas.every((l) => resgatados.has(l.chave));
                      return (
                        <div key={motivo}>
                          <div
                            className="flex items-center justify-between gap-2 px-2 py-1 text-xs"
                            style={{ backgroundColor: 'var(--grid-header-bg)', color: 'var(--grid-header-fg)' }}
                          >
                            <span>
                              <strong className="tabular-nums">{g.linhas.length}</strong> {g.texto}
                            </span>
                            {/* ⛔ So' os motivos que o TEMPO desfaz ganham caixa. Quem pediu pra sair
                                e numero que nao entrega ficam listados e sem porta — e' o que impede
                                a lista de virar uma forma de furar o opt-out sem perceber. */}
                            {g.resgatavel ? (
                              /* ⛔ NAO usar `btn-secundario` aqui: ele nasce com a cor de texto do
                                 tema, que e' feita pra fundo CLARO, e esta faixa usa o par escuro
                                 do cabecalho — medido na tela viva, deu **1,08:1**, invisivel. E'
                                 a [DA-678] repetida. Cor e borda saem do par CASADO da faixa
                                 (`--grid-header-fg` com `--grid-header-bg`), que e' o unico jeito
                                 de o contraste sobreviver aos dois temas. */
                              <button
                                type="button"
                                className="text-xs px-2 py-0.5 rounded"
                                style={{
                                  color: 'var(--grid-header-fg)',
                                  border: '1px solid currentColor',
                                  backgroundColor: 'transparent',
                                }}
                                onClick={() => resgatarGrupo(g.linhas, !todosMarcados)}
                              >
                                {todosMarcados ? 'Tirar todos' : 'Marcar todos'}
                              </button>
                            ) : (
                              <span style={{ opacity: 0.8 }}>não dá para incluir</span>
                            )}
                          </div>
                          {g.linhas.map((l) => (
                            <LinhaContato
                              key={l.chave}
                              nomeContato={l.nome}
                              chave={l.chave}
                              fotoUrl={l.foto_url}
                              marcado={resgatados.has(l.chave)}
                              onToggle={l.resgatavel ? () => alternarResgate(l.chave) : undefined}
                              semWhatsApp={l.motivo === 'numero_nao_entrega'}
                              onExcluir={() => void excluirContatoQuebrado(l.contato_id)}
                              etiquetasDaLinha={etiquetasDaLinha(l.etiqueta_ids)}
                              ultimoEnvio={l.ultimo_envio}
                              diasUltimoEnvio={l.dias_ultimo_envio}
                              destacado={conversaAberta === l.chave}
                              onAbriuConversa={() => setConversaAberta(l.chave)}
                            />
                          ))}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </>
            ) : (
              <div className="flex items-center gap-2 text-xs" style={{ color: 'var(--text-muted)' }}>
                <AlertTriangle size={14} /> Não consegui montar a prévia. Tente escolher a etiqueta de novo.
              </div>
            )}
          </div>
        </div>
      ) : vista === 'config' ? (
        /* ── CONFIGURAÇÕES: os parâmetros de envio ── */
        <AbaParametros
          config={config}
          setConfig={setConfig}
          minutosLojaHoje={painel?.minutos_loja_aberta_hoje ?? 0}
          gravado={painel?.parametros ?? null}
          salvando={salvandoConfig}
          onSalvar={() => { if (config) void salvarParametros(config); }}
        />
      ) : (
        /* ── EM ANDAMENTO ── */
        <div className="flex flex-col" style={{ flex: '1 1 auto', minHeight: 0, overflowY: 'auto' }}>
          {(painel?.campanhas ?? []).length === 0 ? (
            <div className="text-xs px-2 py-3 rounded border" style={{ borderColor: 'var(--border)', color: 'var(--text-muted)' }}>
              Nenhuma campanha ainda.
            </div>
          ) : (painel?.campanhas ?? []).map((c, i) => (
            // GRADE: uma linha entre cada campanha e entre cada coluna (pedido dele, 06/10/2026,
            // com as linhas verticais riscadas no mockup). A cor sai do TEXTO do tema: o `--border`
            // quase some sobre o fundo do modal no Azul Royal, e um tom fixo sumiria no escuro.
            <div
              key={c.id}
              style={{
                borderStyle: 'solid', borderColor: GRADE_CAMPANHA,
                borderWidth: i === 0 ? '1px' : '0 1px 1px 1px',
              }}
            >
            <div className="flex items-stretch">
              {/* O numero da campanha, antes do "+" (pedido dele, 24/09/2026, com print). Largura
                  FIXA: com 1 e 2 digitos na mesma lista, o "+" e o fly nao podem mudar de lugar. */}
              <div style={celulaCampanha(70, 'center', true)}>
              <span
                className="text-sm font-bold text-right"
                // 52px: medido na tela publicada, `Nº 100` pede 46,7px — 44 cortava a partir dali.
                style={{ flex: '0 0 auto', width: 52, fontVariantNumeric: 'tabular-nums', color: 'var(--text-color)' }}
                title={'Campanha nº ' + c.numero}
              >
                Nº {c.numero}
              </span>
              </div>
              {/* O "+" e o fly dividem UMA celula — no mockup ele riscou a grade antes do "+" e
                  depois do fly, nao entre os dois. */}
              <div style={{ ...celulaCampanha(104, 'flex-start'), columnGap: 10, rowGap: 6, flexWrap: 'wrap', alignContent: 'center' }}>
              {/* O "+" que abre a gaveta de quem ja recebeu — mesmo par Plus/Minus do grid da
                  Gestao de Vendas, pra o gesto ser o mesmo em toda a casa. */}
              <button
                type="button"
                className="btn-icon"
                onClick={() => void alternarGavetaCampanha(c.id)}
                aria-label={gavetaCampanha === c.id ? 'Recolher quem recebeu' : 'Ver quem recebeu'}
                title={gavetaCampanha === c.id ? 'Recolher' : 'Ver quem já recebeu'}
                style={{ flex: '0 0 auto' }}
              >
                {gavetaCampanha === c.id ? <Minus size={14} /> : <Plus size={14} />}
              </button>
              {/* O fly da campanha, a esquerda do nome (pedido dele, 23/09/2026); clique amplia no
                  mesmo lightbox do chat. ⚠️ O quadro EXISTE em toda linha, com ou sem arte — senao
                  o nome cai numa abcissa diferente conforme a campanha. */}
              {c.fly_url ? (
                <button
                  type="button"
                  onClick={() => setFlyAmpliado({ url: c.fly_url!, nome: c.nome })}
                  title="Ampliar o fly"
                  aria-label={'Ampliar o fly da campanha ' + c.nome}
                  className="rounded overflow-hidden border"
                  style={{ flex: '0 0 auto', width: 48, height: 48, padding: 0, borderColor: 'var(--border)', cursor: 'zoom-in' }}
                >
                  <img src={c.fly_url} alt="" loading="lazy" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                </button>
              ) : (() => {
                // Sem arte ENVIADA: a PREVIA, desenhada pela mesma funcao do envio (pedido dele,
                // 25/09/2026). ⚠️ Com o selo "prévia" em cima: a miniatura de quem ja mandou e' o
                // que o cliente RECEBEU, e as duas nao podem se confundir.
                const previa = !c.somente_texto && c.produto_ids?.length ? previasLista[c.produto_ids.join('-')] : undefined;
                if (previa && previa !== 'erro') {
                  return (
                    <button
                      type="button"
                      onClick={() => setFlyAmpliado({ url: previa, nome: c.nome + ' (prévia)' })}
                      title="Prévia da arte — ainda não foi enviada. Clique para ampliar."
                      aria-label={'Ampliar a prévia do fly da campanha ' + c.nome}
                      className="rounded overflow-hidden border relative"
                      style={{ flex: '0 0 auto', width: 48, height: 48, padding: 0, borderColor: 'var(--border)', cursor: 'zoom-in' }}
                    >
                      <img src={previa} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                      <span className="absolute left-0 right-0 bottom-0 text-[9px] font-bold text-center" style={{ backgroundColor: '#fde68a', color: '#000', lineHeight: '12px' }}>
                        prévia
                      </span>
                    </button>
                  );
                }
                const motivo = c.somente_texto
                  ? 'Campanha só de texto — sem arte'
                  : motivoRetomar(c)
                    ? 'Sem prévia: ' + motivoRetomar(c)
                    : previa === 'erro'
                      ? 'Não consegui desenhar a prévia desta arte'
                      : 'Desenhando a prévia…';
                return (
                  <span
                    className="rounded border flex items-center justify-center"
                    style={{ flex: '0 0 auto', width: 48, height: 48, borderColor: 'var(--border)', borderStyle: 'dashed', color: 'var(--text-muted)' }}
                    title={motivo}
                  >
                    {c.somente_texto ? <TypeIcon size={16} /> : <ImageIcon size={16} />}
                  </span>
                );
              })()}
              {/* Embaixo do "+" e do quadro vazio, o que falta (pedido dele, 10/10/2026, com print):
                  o quadro tracejado sozinho nao dizia por que a arte nao saiu. */}
              {!c.somente_texto && rotuloFaltaFly(c.produto_ids?.length ?? 0) && (
                <span
                  className="text-[11px] font-bold rounded text-center"
                  style={{ flexBasis: '100%', backgroundColor: '#fde68a', color: '#000', lineHeight: '14px', padding: '2px 4px' }}
                >
                  {rotuloFaltaFly(c.produto_ids?.length ?? 0)}
                </span>
              )}
              </div>
              {/* A celula do nome e' a UNICA elastica: as outras tem largura fixa pra formar coluna.
                  Com nome longo, quem quebra linha e' o texto dela. */}
              <div style={celulaCampanha(null, 'flex-start')}>
              <div style={{ minWidth: 0 }}>
                <div className="text-sm flex items-center gap-1 flex-wrap">
                  <strong>{c.nome}</strong>
                  <span style={{ color: 'var(--text-muted)' }}>· {c.etiqueta}</span>
                  {c.somente_texto && (
                    <span
                      className="inline-flex items-center gap-1 text-xs px-1.5 py-0.5 rounded"
                      style={{ backgroundColor: 'var(--grid-header-bg)', color: 'var(--grid-header-fg)' }}
                      title="Esta campanha manda texto puro, sem arte"
                    >
                      <TypeIcon size={11} /> texto
                    </span>
                  )}
                </div>
                <div className="text-xs" style={{ color: 'var(--text-muted)' }}>
                  <strong className="tabular-nums" style={{ color: 'var(--num-destaque)' }}>{c.enviados}</strong>
                  {' '}de {c.total} enviados
                  {c.pendentes > 0 && c.status !== 'ativa' && ' · ' + c.pendentes + ' na fila'}
                  {c.complementados > 0 && ' · ' + c.complementados + ' sem etiqueta (completando o dia)'}
                  {c.pulados > 0 && ' · ' + c.pulados + ' pulados'}
                  {c.erros > 0 && ' · ' + c.erros + ' com erro'}
                  {c.criado_por && ' · por ' + c.criado_por}
                  {/* Na ATIVA, o que falta sair vira selo no fim do placar (pedido dele, 15/10/2026,
                      com print): o "N na fila" cinza no meio da linha nao era visto. */}
                  {c.status === 'ativa' && c.pendentes > 0 && (
                    <span
                      className="text-[12px] font-bold rounded tabular-nums"
                      style={{ marginLeft: 10, padding: '1px 8px', backgroundColor: '#fde68a', color: '#000', whiteSpace: 'nowrap' }}
                      title="Mensagens na fila desta campanha. Quem deixar de se encaixar ate a vez dele e' pulado."
                    >
                      Faltam {c.pendentes}
                    </span>
                  )}
                  {c.status === 'ativa' && c.pendentes > 0 && (
                    <span
                      className="text-[12px] font-bold rounded tabular-nums"
                      style={{ marginLeft: 6, padding: '1px 8px', backgroundColor: '#fde68a', color: '#000', whiteSpace: 'nowrap' }}
                      title={'Hoje ainda saem ' + (saiHoje.estimado ? 'cerca de ' : '') + saiHoje.n
                        + ': o menor entre a cota que sobra do dia (' + Math.max(0, (painel?.teto_diario ?? 0) - (painel?.enviados_hoje ?? 0))
                        + '), a fila' + (painel?.parametros?.janela_ativa ? ' e o que o ritmo encaixa até ' + painel.parametros.janela_fim : '')
                        + '. A cota do dia é única para todas as campanhas ativas.'}
                    >
                      Hoje: {saiHoje.estimado ? '~' : ''}{Math.min(saiHoje.n, c.pendentes)}
                    </span>
                  )}
                </div>
                {/* O motivo do Retomar apagado mora AQUI, embaixo do placar — ao lado dos botoes
                    ele empurrava Retomar/Editar/Cancelar pra uma segunda linha (print dele). */}
                {c.status === 'pausada' && motivoRetomar(c) && (
                  <div className="text-xs" style={{ color: 'var(--text-muted)', maxWidth: 460 }}>Para retomar: {motivoRetomar(c)}</div>
                )}
              </div>
              </div>
              {/* O carrossel do Instagram (23/09/2026). Morava AO LADO do nome; desde 06/10/2026 tem
                  COLUNA PROPRIA, alinhada nas linhas (ele riscou a grade entre os dois no mockup).
                  Campanha so' de texto deixa a celula vazia. So' campanha com arte. Abre a previa; publicar e' um segundo gesto,
                  la dentro. ⚠️ `btn-primario`: e' a unica porta, e `btn-secundario` sozinho some
                  no fundo da linha ([DA-667]). */}
              {/* O rotulo diz em que pe a publicacao esta (06/10/2026: a #14 falhou no IG e o
                  botao seguia "Publicar no Instagram", igual a quem nunca tentou — ele leu como
                  publicada e o botao como defeito). Falha = laranja solido + letra preta. */}
              <div style={celulaCampanha(190, 'center')}>
              {!c.somente_texto && (
                <button
                  type="button"
                  className={c.instagram_status === 'erro_publicar' || c.instagram_status === 'erro'
                    ? 'text-xs flex items-center gap-1 rounded px-3 py-1.5 font-semibold text-left'
                    : 'btn-primario text-xs flex items-center gap-1 text-left'}
                  onClick={() => setCarrosselDe(c.id)}
                  title="Gerar os vídeos e publicar esta campanha como carrossel no Instagram"
                  style={c.instagram_status === 'erro_publicar' || c.instagram_status === 'erro'
                    ? { flex: '0 0 auto', backgroundColor: '#f97316', color: '#000', border: '1px solid #c2410c' }
                    : { flex: '0 0 auto' }}
                >
                  {c.instagram_status === 'erro_publicar' || c.instagram_status === 'erro'
                    ? <AlertTriangle size={13} />
                    : <Instagram size={13} />}
                  {c.instagram_status === 'publicado' ? 'No Instagram ✓'
                    : c.instagram_status === 'erro_publicar' ? 'Instagram: não publicou — ver'
                    : c.instagram_status === 'erro' ? 'Instagram: vídeos falharam — ver'
                    : c.instagram_status === 'publicando' ? 'Publicando no Instagram…'
                    : c.instagram_status === 'gerando' ? 'Gerando vídeos…'
                    : 'Publicar no Instagram'}
                </button>
              )}
              </div>
              {/* A DATA INICIAL, em lugar proprio (pedido dele, 25/09/2026: *"fica mais facil de
                  entender quando a campanha vai comecar"*). Dentro do placar cinza, em 10,5px, ela
                  nao era vista. Largura fixa: as datas das linhas formam uma coluna. Ainda nao
                  chegou, diz "Começa em" — senao a campanha ativa parada le como travada. */}
              <div style={celulaCampanha(240, 'flex-end')}>
              <span className="tabular-nums" style={{ width: '100%', minWidth: 0, textAlign: 'right', color: 'var(--text-color)' }}>
                <span className="text-[13px]">
                  {c.aguardando_inicio ? 'Começa em ' : 'Início '}
                  <strong>{formatDataSP(c.inicia_em)}</strong>
                </span>
                {/* Quantos sairam em CADA dia (pedido dele, 25/09/2026: *"nao sei quantos foi
                    disparado no dia 23 e no 24"*). Soma igual ao "N de M enviados" da esquerda. */}
                {c.por_dia && c.por_dia.length > 0 && (
                  <span className="block text-[12px]" style={{ color: 'var(--text-color)' }}>
                    {/* `inline-block` em cada dia: e' o que deixa a lista QUEBRAR entre um dia e
                        outro. Com tudo `nowrap` ela nao tinha onde quebrar e, com 5 dias (346px),
                        passava por cima do status (print dele, 06/10/2026). */}
                    {c.por_dia.map((d, i) => (
                      <span key={d.dia} style={{ whiteSpace: 'nowrap', display: 'inline-block', marginLeft: i > 0 ? 3 : 0 }}>
                        {i > 0 && '· '}
                        {d.dia.slice(8, 10) + '/' + d.dia.slice(5, 7)}: <strong>{d.n}</strong>
                      </span>
                    ))}
                  </span>
                )}
              </span>
              </div>
              {/* Status e botoes com LARGURA FIXA (pedido dele, 25/09/2026: a coluna da data tem que
                  ficar alinhada). Desde 06/10/2026 cada botao tem a SUA coluna da grade: Pausar ou
                  Retomar | Editar | Cancelar ou Republicar. */}
              <div style={celulaCampanha(100, 'center')}>
              <span
                className="text-xs px-2 py-0.5 rounded text-center"
                style={{
                  flex: '0 0 auto', width: 76,
                  backgroundColor: c.status === 'ativa' ? '#fde68a' : 'transparent',
                  color: c.status === 'ativa' ? '#000' : 'var(--text-muted)',
                  border: c.status === 'ativa' ? 'none' : '1px solid var(--border)',
                }}
              >
                {c.status}
              </span>
              </div>
              <div style={celulaCampanha(100, 'center')}>
                {c.status === 'ativa' && (
                  <button type="button" className="btn-secundario text-xs flex items-center gap-1" onClick={() => void agir(c, 'pausar')}>
                    <Pause size={12} /> Pausar
                  </button>
                )}
                {/* Retomar poe a arte pra sair: com 4 a 11 produtos (salvos pausados, decisao dele
                    23/09/2026) ele apaga e a linha diz o que falta — o servidor recusa igual. */}
                {c.status === 'pausada' && (() => {
                  const motivo = motivoRetomar(c);
                  return (
                    <>
                      <button
                        type="button"
                        className="btn-secundario text-xs flex items-center gap-1"
                        disabled={!!motivo}
                        title={motivo ? 'Edite a campanha: ' + motivo : undefined}
                        onClick={() => void agir(c, 'retomar')}
                      >
                        <Play size={12} /> Retomar
                      </button>
                    </>
                  );
                })()}
              </div>
              <div style={celulaCampanha(90, 'center')}>
                {/* So' PAUSADA se edita (decisao dele, 23/09/2026) — apagado na ativa, dizendo por que. */}
                {(c.status === 'ativa' || c.status === 'pausada') && (
                  <button
                    type="button"
                    className="btn-secundario text-xs flex items-center gap-1"
                    disabled={c.status !== 'pausada'}
                    title={c.status === 'pausada'
                      ? 'Muda o que sai para quem ainda não recebeu — quem já recebeu fica como está'
                      : 'Pause a campanha para editar'}
                    onClick={() => void abrirEdicao(c)}
                  >
                    <Pencil size={12} /> Editar
                  </button>
                )}
              </div>
              <div style={celulaCampanha(130, 'center')}>
                {(c.status === 'ativa' || c.status === 'pausada') && (
                  <button type="button" className="btn-secundario text-xs flex items-center gap-1" onClick={() => void agir(c, 'cancelar')}>
                    <X size={12} /> Cancelar
                  </button>
                )}
                {/* Campanha que ja rodou nao se edita: ela vira ponto de partida de uma NOVA (pedido
                    dele, 06/10/2026). `btn-primario`: e' a unica porta, e sozinho na linha o
                    secundario some ([DA-667]). */}
                {(c.status === 'concluida' || c.status === 'cancelada') && (
                  <button
                    type="button"
                    className="btn-primario text-xs flex items-center gap-1"
                    title="Abre uma campanha nova com o mesmo fly, texto e etiquetas — você ajusta e publica. Só recebe quem está fora da frequência de fly das etiquetas dele."
                    onClick={() => void abrirEdicao(c, undefined, flys, true)}
                  >
                    <Pencil size={12} /> Republicar
                  </button>
                )}
              </div>
            </div>

            {/* A gaveta: quem ja recebeu DESTA campanha, com a hora e o intervalo. */}
            {gavetaCampanha === c.id && (
              <div className="px-3 py-2" style={{ borderTop: '1px solid ' + GRADE_CAMPANHA }}>
                <GavetaRecebeu
                  linhas={linhasCampanha}
                  carregando={carregandoGaveta}
                  // O vazio diz QUANDO sai de verdade: "no próximo tique" era mentira na campanha
                  // com data futura (25/09/2026) e na pausada.
                  vazio={c.aguardando_inicio
                    ? 'Nenhum envio ainda — os envios começam em ' + formatDataSP(c.inicia_em) + '.'
                    : c.status === 'pausada'
                      ? 'Nenhum envio ainda — a campanha está pausada.'
                      : 'Nenhum envio ainda — a primeira mensagem sai no próximo tique.'}
                />
              </div>
            )}
            </div>
          ))}
        </div>
      )}
      {carrosselDe !== null && (
        <ModalCarrosselInstagram
          campanhaId={carrosselDe}
          onFechar={() => { setCarrosselDe(null); void carregarPainel(); }}
          onMudou={() => void carregarPainel()}
        />
      )}
      {ordemAberta && (
        <ModalOrdemProdutosFly
          produtos={produtosAdHoc}
          // A lista volta como ProdutoOrdem; reponho os objetos ORIGINAIS na ordem nova, pra nao
          // perder campo que so' esta tela conhece (`tem_descricao_comercial`).
          onAplicar={(ordem) => setProdutosAdHoc(ordem.map((o) => produtosAdHoc.find((p) => p.id === o.id)!).filter(Boolean))}
          onFechar={() => setOrdemAberta(false)}
        />
      )}
      {flyAmpliado && (
        <LightboxImagem
          imagens={[{ url: flyAmpliado.url, legenda: flyAmpliado.nome }]}
          onFechar={() => setFlyAmpliado(null)}
        />
      )}
    </Modal>
  );
}
